// /* eslint-disable eqeqeq */
// import React, { Fragment } from "react";
// import PropTypes from "prop-types";
// import { withStyles } from "@material-ui/styles";
// import {
//   Grid,
//   MenuItem,
//   TextField,
//   Typography,
//   Button,
//   Divider,
//   CircularProgress,
//   Card,
//   CardContent,
//   Toolbar, Tooltip, Box,
//   Dialog, DialogTitle, DialogContent, Chip,
// } from "@material-ui/core";
// import Select from "react-select";
// import { HttpRequest } from "../../../utils/httpRequests";
// import NavBar from "../../../components/NavBar/NavBar";
// import CustomizedSnackbar from "../../../components/CustomizedSnackbar/CustomizedSnackbar";
// import LoginMenu from "../../../components/LoginMenu/LoginMenu";
// import BottomBar from "../../../components/BottomBar/BottomBar";
// import { Close as CloseIcon } from "@material-ui/icons";
// import PublishIcon from "@material-ui/icons/Publish";
// import { IconButton } from "@material-ui/core";
// import ckLogo from "../../../assets/images/ck_logo_new.png";
// import LayoutMethods from '../../../components/Layouts/layoutMethods';



// // ── Layout preview: empty container with correct aspect ratio + red slot squares + dimension labels ──
// const LayoutPreview = ({ exportWidth, exportHeight, collageInfoList }) => {
//   if (!exportWidth || !exportHeight) return null;

//   const ratio = exportWidth / exportHeight;
//   const paddingTop = (1 / ratio) * 100;

//   return (
//     <div style={{ marginTop: 10 }}>
//       {/* canvas dimensions label */}
//       <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center", marginBottom: 3 }}>
//         <span style={{ fontSize: 9, color: "#7986cb", fontWeight: 600, letterSpacing: 0.3 }}>
//           LAYOUT PREVIEW
//         </span>
//         <span style={{ fontSize: 9, color: "#9fa8da", fontWeight: 500 }}>
//           {exportWidth} × {exportHeight} px
//         </span>
//       </div>

//       {/* aspect-ratio container */}
//       <div style={{ position: "relative", width: "100%", paddingTop: `${paddingTop}%`, backgroundColor: "#e8eaf6", border: "1.5px solid #9fa8da", borderRadius: 4, overflow: "hidden" }}>
//         {/* subtle grid */}
//         <div style={{
//           position: "absolute", inset: 0,
//           backgroundImage: "linear-gradient(rgba(0,0,0,0.05) 1px, transparent 1px), linear-gradient(90deg, rgba(0,0,0,0.05) 1px, transparent 1px)",
//           backgroundSize: "10% 10%",
//         }} />

//         {/* red slot rectangles */}
//         {collageInfoList && collageInfoList.map((info, i) => {
//           const slotWpx = Math.round(info.getWidth() * exportWidth);
//           const slotHpx = Math.round(info.getHeight() * exportHeight);
//           const slotLpx = Math.round(info.getLeft() * exportWidth);
//           const slotTpx = Math.round(info.getTop() * exportHeight);
//           return (
//             <div
//               key={i}
//               style={{
//                 position: "absolute",
//                 left: `${info.getLeft() * 100}%`,
//                 top: `${info.getTop() * 100}%`,
//                 width: `${info.getWidth() * 100}%`,
//                 height: `${info.getHeight() * 100}%`,
//                 backgroundColor: "rgba(211, 47, 47, 0.15)",
//                 border: "2px solid rgba(211, 47, 47, 0.85)",
//                 borderRadius: 2,
//                 boxSizing: "border-box",
//                 display: "flex",
//                 flexDirection: "column",
//                 alignItems: "center",
//                 justifyContent: "center",
//                 gap: 1,
//                 padding: 2,
//               }}
//             >
//               <span style={{ fontSize: 8, color: "rgba(183,28,28,0.95)", fontWeight: 700, letterSpacing: 0.4, userSelect: "none", lineHeight: 1.2 }}>
//                 SLOT {i + 1}
//               </span>
//               <span style={{ fontSize: 7, color: "rgba(183,28,28,0.8)", fontWeight: 500, userSelect: "none", lineHeight: 1.2 }}>
//                 {slotWpx} × {slotHpx}
//               </span>
//               <span style={{ fontSize: 7, color: "rgba(120,20,20,0.6)", fontWeight: 400, userSelect: "none", lineHeight: 1.2 }}>
//                 @ {slotLpx}, {slotTpx}
//               </span>
//             </div>
//           );
//         })}

//         {/* empty state */}
//         {(!collageInfoList || collageInfoList.length === 0) && (
//           <div style={{ position: "absolute", inset: 0, display: "flex", alignItems: "center", justifyContent: "center" }}>
//             <span style={{ fontSize: 10, color: "#9fa8da", fontWeight: 500 }}>Select layout to preview</span>
//           </div>
//         )}
//       </div>

//       {/* per-slot dimension rows below container */}
//       {collageInfoList && collageInfoList.length > 0 && (
//         <div style={{ marginTop: 5 }}>
//           {collageInfoList.map((info, i) => (
//             <div key={i} style={{ display: "flex", justifyContent: "space-between", marginBottom: 2 }}>
//               <span style={{ fontSize: 8, color: "#d32f2f", fontWeight: 600 }}>Slot {i + 1}</span>
//               <span style={{ fontSize: 8, color: "#555" }}>
//                 {Math.round(info.getWidth() * exportWidth)} × {Math.round(info.getHeight() * exportHeight)} px
//               </span>
//               <span style={{ fontSize: 8, color: "#888" }}>
//                 x:{Math.round(info.getLeft() * exportWidth)}  y:{Math.round(info.getTop() * exportHeight)}
//               </span>
//             </div>
//           ))}
//         </div>
//       )}
//     </div>
//   );
// };

// // ── Layout Picker Dialog ──
// class LayoutPickerDialog extends React.Component {
//   constructor(props) {
//     super(props);
//     this.state = { selectedPictures: null };
//   }

//   componentDidUpdate(prev) {
//     if (!prev.open && this.props.open) {
//       // when dialog opens, pre-set filter from parent (picture count dropdown selection)
//       this.setState({ selectedPictures: this.props.initialFilter ?? null });
//     }
//   }

//   render() {
//     const { open, onClose, layoutsList, onSelect, selectedLayoutId, getCollageOverlay, pageNumber } = this.props;
//     const { selectedPictures } = this.state;

//     // distinct totalPictures values
//     const pictureOptions = [...new Set(
//       layoutsList.map((l) => l.totalPictures).filter((v) => v != null)
//     )].sort((a, b) => a - b);

//     const filtered = layoutsList.filter((l) =>
//       selectedPictures == null ? true : l.totalPictures === selectedPictures
//     );

//     return (
//       <Dialog open={open} onClose={onClose} maxWidth="md" fullWidth
//         PaperProps={{ style: { borderRadius: 12, maxHeight: "90vh" } }}>
//         <DialogTitle style={{ paddingBottom: 8 }}>
//           <Box display="flex" alignItems="center" justifyContent="space-between">
//             <Typography variant="h6" style={{ fontWeight: 700, color: "#333" }}>
//               Select Layout
//             </Typography>
//             <IconButton size="small" onClick={onClose}>
//               <CloseIcon />
//             </IconButton>
//           </Box>

//           {/* picture count filter chips */}
//           <Box display="flex" flexWrap="wrap" style={{ gap: 6, marginTop: 10 }}>
//             <Chip
//               label="All"
//               size="small"
//               onClick={() => this.setState({ selectedPictures: null })}
//               style={{
//                 backgroundColor: selectedPictures == null ? "#1976d2" : "#e0e0e0",
//                 color: selectedPictures == null ? "#fff" : "#333",
//                 fontWeight: 600, cursor: "pointer",
//               }}
//             />
//             {pictureOptions.map((n) => (
//               <Chip
//                 key={n}
//                 label={`${n} Picture${n !== 1 ? "s" : ""}`}
//                 size="small"
//                 onClick={() => this.setState({ selectedPictures: n })}
//                 style={{
//                   backgroundColor: selectedPictures === n ? "#1976d2" : "#e0e0e0",
//                   color: selectedPictures === n ? "#fff" : "#333",
//                   fontWeight: 600, cursor: "pointer",
//                 }}
//               />
//             ))}
//           </Box>
//         </DialogTitle>

//         <DialogContent dividers style={{ padding: 16 }}>
//           {filtered.length === 0 && (
//             <Typography variant="body2" style={{ color: "#888", textAlign: "center", marginTop: 32 }}>
//               No layouts available.
//             </Typography>
//           )}
//           <Grid container spacing={2}>
//             {filtered.map((layout) => {
//               const overlay = getCollageOverlay(layout.layoutId, pageNumber);
//               const isSelected = String(selectedLayoutId) === String(layout.layoutId);
//               return (
//                 <Grid item xs={12} sm={6} md={4} key={layout.layoutId}>
//                   <Card
//                     elevation={isSelected ? 6 : 2}
//                     onClick={() => { onSelect(layout.layoutId); onClose(); }}
//                     style={{
//                       borderRadius: 8,
//                       border: isSelected ? "2px solid #1976d2" : "2px solid transparent",
//                       cursor: "pointer",
//                       transition: "box-shadow 0.15s, border 0.15s",
//                       overflow: "hidden",
//                     }}
//                   >
//                     {/* preview area */}
//                     <Box style={{ padding: "10px 10px 0 10px", backgroundColor: isSelected ? "#e3f2fd" : "#fafafa" }}>
//                       <LayoutPreview
//                         exportWidth={overlay ? overlay.exportWidth : null}
//                         exportHeight={overlay ? overlay.exportHeight : null}
//                         collageInfoList={overlay ? overlay.collageInfoList : null}
//                       />
//                     </Box>

//                     {/* info footer */}
//                     <CardContent style={{ padding: "8px 10px 10px 10px", backgroundColor: isSelected ? "#e3f2fd" : "#fff" }}>
//                       <Box display="flex" alignItems="center" justifyContent="space-between">
//                         <Typography variant="caption" style={{ fontWeight: 700, color: isSelected ? "#1976d2" : "#333", fontSize: 12 }}>
//                           {layout.layoutNo}{layout.label ? ` — ${layout.label}` : ""}
//                         </Typography>
//                         {isSelected && (
//                           <Chip label="Selected" size="small" style={{ backgroundColor: "#1976d2", color: "#fff", fontSize: 9, height: 18 }} />
//                         )}
//                       </Box>
//                       {layout.totalPictures != null && (
//                         <Typography variant="caption" style={{ color: "#888", display: "block", marginTop: 2 }}>
//                           {layout.totalPictures} picture{layout.totalPictures !== 1 ? "s" : ""}
//                         </Typography>
//                       )}
//                     </CardContent>
//                   </Card>
//                 </Grid>
//               );
//             })}
//           </Grid>
//         </DialogContent>
//       </Dialog>
//     );
//   }
// }

// const getExpectedAspectRatio = (sizeId, pageNumber, slotNumber, categoryId) => {
//   // slotNumber 1 = App Asset (ic), slotNumber 2 = Print Asset (fl)
//   // ic and fl share the same aspect ratio — ic is just a scaled-down version.
//   const id = parseInt(categoryId);
//   const totalPages = { 2: 24, 6: 12, 9: 1 }[id] || 0;
//   const isFrontCover = pageNumber === 1;
//   const isBackCover = pageNumber === totalPages && totalPages > 1;

//   if (id === 2) {
//     if (sizeId === 2) {
//       if (isFrontCover) return 3796 / 3000;
//       if (isBackCover) return 4010 / 3000;
//       return 3508 / 2400;
//     }
//     if (sizeId === 4) {
//       if (isFrontCover) return 2737 / 3000;
//       if (isBackCover) return 2961 / 3000;
//       return 2400 / 2400;
//     }
//   } else if (id === 9) {
//     if (sizeId === 22) return 2550 / 1050;
//     if (sizeId === 23) return 2550 / 1125;
//     return 2550 / 1050;
//   } else if (id === 6) {
//     if (sizeId === 12 || sizeId === 14) return 3600 / 5400;
//     if (sizeId === 15) return 3600 / 3600;
//     return 3600 / 5400;
//   }


//   // if (id === 2) {
//   //   if (sizeLabel === "Landscape") {
//   //     if (isFrontCover) return 3796 / 3000; // 1.2653
//   //     if (isBackCover) return 4010 / 3000; // 1.3367
//   //     return 3508 / 2400; // 1.4617 — Inner Pages
//   //   }
//   //   if (sizeLabel === "Square") {
//   //     if (isFrontCover) return 2737 / 3000; // 0.9123
//   //     if (isBackCover) return 2961 / 3000; // 0.9870
//   //     return 2400 / 2400; // 1.0000 — Inner Pages
//   //   }
//   // } else if (id === 6) {       // ← ADDED HERE
//   //   if (sizeLabel === "Classic 12x18''" || sizeLabel === "Portrait 12x18''") return 3600 / 5400;
//   //   if (sizeLabel === "Square 12x12''") return 3600 / 3600;
//   //   return 3600 / 5400;
//   // }

//   // else if (id === 9) {
//   //   if (sizeLabel === "Regular Mug") return 2550 / 1050; // 2.4286
//   //   if (sizeLabel === "Big Mug") return 2550 / 1125; // 2.2667
//   //   return 2550 / 1050; // fallback
//   // }

//   return null; // no rule — skip validation
// };

// const ASPECT_RATIO_TOLERANCE = 0.01; // ±0.01 ratio tolerance (~0.8%)

// const useStyles = () => ({
//   root: {
//     padding: 10,
//     margin: "70px 20px",
//   },
//   topMargin: {
//     marginTop: 20,
//   },
//   button: {
//     textTransform: "capitalize",
//     marginLeft: 10,
//     padding: 10,
//     width: 110,
//   },
//   sectionLabel: {
//     fontWeight: 600,
//     color: "#555",
//     marginBottom: 8,
//     marginTop: 16,
//   },
// });

// class F15AddNewThemeForm extends React.Component {
//   constructor(props) {
//     super(props);

//     this.state = {
//       isLoading: false,
//       recordId: 0,

//       // ── Dropdown Data ──
//       categoriesList: [],
//       categoriesLoading: false,

//       themeCategoriesList: [],
//       themeCategoriesLoading: false,

//       sizesList: [],
//       sizesLoading: false,

//       totalPagesList: [],

//       productTypesList: [],
//       productTypesLoading: false,

//       bundlesList: [],
//       bundlesLoading: false,

//       // ── Selected Values ──
//       categoryId: "",
//       categoryIdError: "",

//       themeCategoryId: "",
//       themeCategoryIdError: "",

//       sizeId: "",
//       sizeIdError: "",

//       totalPages: "",
//       totalPagesError: "",

//       selectedProductTypes: [],
//       selectedProductTypesError: "",

//       layoutsList: [],
//       layoutsLoading: false,

//       selectedLayouts: [],
//       selectedLayoutsError: "",

//       // bundleId: "",
//       // bundleIdError: "",
//       selectedBundles: [],
//       selectedBundlesError: "",


//       // ── Text Fields ──
//       description: "",
//       descriptionError: "",

//       themeLabel: "",
//       themeLabelError: "",

//       // ── UI State ──
//       isOpenSnackbar: false,
//       snackbarMessage: "",
//       snackbarSeverity: "",
//       isLoginMenu: false,
//       isReload: true,
//       layoutPickerOpenPage: null, // pageNumber of the dialog currently open, or null
//       templateImages: [], // array of { pageNumber, slotNumber, file, preview }
//     };
//   }

//   componentDidMount() {
//     this.fetchCategories();
//     this.fetchThemeCategories();

//     // 


//     const id = this.props.match?.params?.recordId;
//     if (id && id != 0) {
//       this.setState({ recordId: id });
//       this.getData(id);
//     }
//   }

//   UNSAFE_componentWillReceiveProps(nextProps) {
//     if (this.props.match?.params?.recordId != nextProps.match?.params?.recordId) {
//       if (nextProps.match?.params?.recordId != 0) {
//         this.getData(nextProps.match?.params?.recordId);
//       } else {
//         window.location.reload();
//       }
//     }
//   }

//   buildTemplateSlots = (categoryId) => {
//     const pagesMap = { 2: 24, 6: 12, 9: 1 };
//     const totalPages = pagesMap[parseInt(categoryId)] || 0;
//     const imagesPerPage = 2;
//     const slotLabels = { 1: "App Asset", 2: "Print Asset" };

//     const slots = [];
//     for (let page = 1; page <= totalPages; page++) {
//       for (let slot = 1; slot <= imagesPerPage; slot++) {
//         slots.push({
//           pageNumber: page,
//           slotNumber: slot,
//           slotLabel: slotLabels[slot],
//           slotKey: `page${page}_slot${slot}`,
//           file: null,
//           preview: null,
//           dimensions: null,
//           layoutId: "",      // ← new
//           layoutIdError: "", // ← new
//         });
//       }
//     }
//     this.setState({ templateImages: slots });
//   };
//   // buildTemplateSlots = (categoryId) => {
//   //   const pagesMap = { 2: 24, 6: 12, 9: 1 };
//   //   const totalPages = pagesMap[categoryId] || 0;
//   //   const imagesPerPage = 2;
//   //   const slotLabels = { 1: "App Asset", 2: "Print Asset" };

//   //   const slots = [];
//   //   for (let page = 1; page <= totalPages; page++) {
//   //     for (let slot = 1; slot <= imagesPerPage; slot++) {
//   //       slots.push({
//   //         pageNumber: page,
//   //         slotNumber: slot,
//   //         slotLabel: slotLabels[slot],
//   //         slotKey: `page${page}_slot${slot}`,
//   //         file: null,
//   //         preview: null,
//   //       });
//   //     }
//   //   }
//   //   this.setState({ templateImages: slots });
//   // };

//   // buildTemplateSlots = (categoryId) => {
//   //   const pagesMap = { 2: 24, 6: 12, 9: 1 };
//   //   const totalPages = pagesMap[categoryId] || 0;
//   //   const imagesPerPage = 2;

//   //   const slots = [];
//   //   for (let page = 1; page <= totalPages; page++) {
//   //     for (let slot = 1; slot <= imagesPerPage; slot++) {
//   //       slots.push({
//   //         pageNumber: page,
//   //         slotNumber: slot,
//   //         slotKey: `page${page}_slot${slot}`,
//   //         file: null,
//   //         preview: null,
//   //       });
//   //     }
//   //   }
//   //   this.setState({ templateImages: slots });
//   // };

//   handleTemplateLayoutChange = (slotKey, layoutId) => {
//     this.setState((prev) => ({
//       templateImages: prev.templateImages.map((slot) =>
//         slot.slotKey === slotKey
//           ? { ...slot, layoutId, layoutIdError: "" }
//           : slot
//       ),
//     }));
//   };

//   fetchCategories = async () => {
//     this.setState({ categoriesLoading: true });
//     const res = await HttpRequest(
//       "GET",
//       `${process.env.REACT_APP_API_DOMAIN}/${process.env.REACT_APP_SUB_API_NAME}/common/C15CommonProductsCategoriesView`,
//       null,
//       "authorizeJson"
//     );
//     if (res.isSuccess) {
//       const ALLOWED_IDS = [2, 6, 9];
//       const ALIAS_MAP = { 2: "pb", 6: "cl", 9: "mg" };
//       const filtered = (res.data || [])
//         .filter((item) => ALLOWED_IDS.includes(item.id))
//         .map((item) => ({ ...item, alias: ALIAS_MAP[item.id] || "" }));
//       this.setState({ categoriesList: filtered });
//     } else {
//       if (res.statusCode === 401) this.setState({ isLoginMenu: true });
//     }
//     this.setState({ categoriesLoading: false });
//   };

//   // fetchPages = async (categoryId) => {
//   //   this.setState({ categoriesLoading: true });
//   //   const res = await HttpRequest(
//   //     "GET",
//   //     `${process.env.REACT_APP_API_DOMAIN}/${process.env.REACT_APP_SUB_API_NAME}/common/C15CommonProductsPagesView?categoryId=${categoryId}`,
//   //     null,
//   //     "authorizeJson"
//   //   );
//   //   if (res.isSuccess) {

//   //     this.setState({ totalPagesList: res.data || [] });
//   //   } else {
//   //     if (res.statusCode === 401) this.setState({ isLoginMenu: true });
//   //   }
//   //   this.setState({ categoriesLoading: false });
//   // };

//   buildTotalPagesList = (categoryId) => {
//     let pages = [];

//     if (categoryId == 2) {
//       pages = [{ value: 24, label: "24 Pages" }];
//     } else if (categoryId == 6) {
//       pages = [{ value: 12, label: "12 Pages" }];
//     } else if (categoryId == 9) {
//       pages = [{ value: 1, label: "1 Page" }];
//     }

//     this.setState({ totalPagesList: pages, totalPages: pages.length === 1 ? pages[0].value : "" });
//   };




//   fetchThemeCategories = async () => {
//     this.setState({ themeCategoriesLoading: true });
//     const res = await HttpRequest(
//       "GET",
//       `${process.env.REACT_APP_API_DOMAIN}/${process.env.REACT_APP_SUB_API_NAME}/common/C15CommonProductsThemeCategoriesView`,
//       null,
//       "authorizeJson"
//     );
//     if (res.isSuccess) {
//       this.setState({ themeCategoriesList: res.data || [] });
//     } else {
//       if (res.statusCode === 401) this.setState({ isLoginMenu: true });
//     }
//     this.setState({ themeCategoriesLoading: false });
//   };

//   fetchSizes = async (categoryId) => {
//     this.setState({ sizesLoading: true });
//     const res = await HttpRequest(
//       "GET",
//       `${process.env.REACT_APP_API_DOMAIN}/${process.env.REACT_APP_SUB_API_NAME}/common/C15CommonProductsSizesView?categoryId=${categoryId}`,
//       null,
//       "authorizeJson"
//     );
//     if (res.isSuccess) {
//       this.setState({ sizesList: res.data || [] });
//     } else {
//       if (res.statusCode === 401) this.setState({ isLoginMenu: true });
//     }
//     this.setState({ sizesLoading: false });
//   };



//   fetchLayouts = async (categoryId) => {
//     this.setState({ layoutsLoading: true });
//     const res = await HttpRequest(
//       "GET",
//       `${process.env.REACT_APP_API_DOMAIN}/${process.env.REACT_APP_SUB_API_NAME}/common/C15CommonProductsThemeAssetsLayoutsController?categoryId=${categoryId}`,
//       null,
//       "authorizeJson"
//     );
//     if (res.isSuccess) {
//       this.setState({ layoutsList: res.data || [] });
//     } else {
//       if (res.statusCode === 401) this.setState({ isLoginMenu: true });
//     }
//     this.setState({ layoutsLoading: false });
//   };



//   fetchProductTypes = async (categoryId) => {
//     this.setState({ productTypesLoading: true });
//     const res = await HttpRequest(
//       "GET",
//       `${process.env.REACT_APP_API_DOMAIN}/${process.env.REACT_APP_SUB_API_NAME}/common/C15CommonProductsTypesView?categoryId=${categoryId}`,
//       null,
//       "authorizeJson"
//     );
//     if (res.isSuccess) {
//       const list = (res.data || []).map((item) => ({
//         value: item.id,
//         label: item.label,
//         id: item.id,
//         isFixed: false,
//         isDisabled: false,
//       }));
//       this.setState({ productTypesList: list });
//     } else {
//       if (res.statusCode === 401) this.setState({ isLoginMenu: true });
//     }
//     this.setState({ productTypesLoading: false });
//   };

//   // fetchBundles = async (categoryId) => {
//   //   this.setState({ bundlesLoading: true });
//   //   if (categoryId == 9) {
//   //     this.setState({ bundlesList: [{ value: 1, label: "Bundle of 1" }, { value: 2, label: "Bundle of 2" }] });
//   //   }
//   //   this.setState({ bundlesLoading: false });
//   // };

//   fetchBundles = async (categoryId) => {
//     this.setState({ bundlesLoading: true });
//     if (categoryId == 9) {
//       this.setState({
//         bundlesList: [
//           { value: 1, label: "Bundle of 1", id: 1 },
//           { value: 2, label: "Bundle of 2", id: 2 },
//         ],
//       });
//     } else {
//       this.setState({ bundlesList: [] });
//     }
//     this.setState({ bundlesLoading: false });
//   };

//   getData = async (id) => {
//     const res = await HttpRequest(
//       "GET",
//       `${process.env.REACT_APP_API_DOMAIN}/${process.env.REACT_APP_SUB_API_NAME}/common/C15ALLThemesFormView?recordId=${id}`,
//       null,
//       "authorizeJson"
//     );
//     if (res.isSuccess && res.data && res.data.length > 0) {
//       const d = res.data[0];
//       this.setState({
//         categoryId: d.categoryId || "",
//         themeCategoryId: d.themeCategoryId || "",
//         sizeId: d.sizeId || "",
//         totalPages: d.totalPages || "",
//         bundleId: d.bundleId || "",
//         description: d.description || "",
//         themeLabel: d.themeLabel || "",
//         selectedProductTypes: d.productTypes
//           ? d.productTypes.map((pt) => ({ value: pt.id, label: pt.label, id: pt.id }))
//           : [],
//       });
//     } else {
//       if (res.statusCode === 401) this.setState({ isLoginMenu: true });
//       else this.handleSnackbar(true, res.message || "Failed to load data", "error");
//     }
//   };

//   // handleChange = (e) => {
//   //   const { name, value } = e.target;
//   //   this.setState({
//   //     [name]: value || "",
//   //     [`${name}Error`]: "",
//   //   }, () => {
//   //     if (name === "categoryId" && value) {
//   //       this.fetchSizes(value);
//   //       this.fetchProductTypes(value);
//   //       this.fetchBundles(value);
//   //       this.buildTotalPagesList(value);
//   //       this.buildTemplateSlots(value); // ← add this
//   //     }
//   //   });
//   // };

//   handleChange = (e) => {
//     const { name, value } = e.target;

//     // ── Category change — warn only if themeCategoryId already selected ──
//     if (name === "categoryId") {
//       if (this.state.themeCategoryId) {
//         this.confirmReset(
//           "Changing the category will reset all progress. Continue?",
//           () => {
//             this.setState({
//               [name]: value || "",
//               [`${name}Error`]: "",
//               themeCategoryId: "",
//               themeCategoryIdError: "",
//               sizeId: "",
//               sizeIdError: "",
//               totalPages: "",
//               totalPagesError: "",
//               selectedProductTypes: [],
//               selectedProductTypesError: "",
//               selectedBundles: [],
//               selectedBundlesError: "",
//               bundlesList: [],
//               sizesList: [],
//               productTypesList: [],
//               layoutsList: [],
//               themeLabel: "",
//               themeLabelError: "",
//               description: "",
//               descriptionError: "",
//               templateImages: [],
//               previewImage: null,
//               thumbnailImage: null,
//             }, () => {
//               if (value) {
//                 this.fetchSizes(value);
//                 this.fetchProductTypes(value);
//                 this.buildTotalPagesList(value);
//                 this.buildTemplateSlots(value);
//                 this.fetchLayouts(value);
//                 this.fetchBundles(value);
//               }
//             });
//           }
//         );
//       } else {
//         this.setState({ [name]: value || "", [`${name}Error`]: "" }, () => {
//           if (value) {
//             this.fetchSizes(value);
//             this.fetchProductTypes(value);
//             this.buildTotalPagesList(value);
//             this.buildTemplateSlots(value);
//             this.fetchLayouts(value);
//             this.fetchBundles(value);
//           }
//         });
//       }
//       return;
//     }

//     // ── Theme Category change — warn only if sizeId already selected ──
//     if (name === "themeCategoryId") {
//       if (this.state.sizeId) {
//         this.confirmReset(
//           "Changing the theme category will reset size, images and selections. Continue?",
//           () => {
//             this.setState({
//               [name]: value || "",
//               [`${name}Error`]: "",
//               sizeId: "",
//               sizeIdError: "",
//               totalPages: "",
//               totalPagesError: "",
//               selectedProductTypes: [],
//               selectedProductTypesError: "",
//               selectedBundles: [],
//               selectedBundlesError: "",
//               themeLabel: "",
//               themeLabelError: "",
//               description: "",
//               descriptionError: "",
//               // Keep slot structure intact — only clear uploaded file data
//               templateImages: this.state.templateImages.map((slot) => ({
//                 ...slot,
//                 file: null,
//                 preview: null,
//                 dimensions: null,
//                 generatedFileName: "",
//                 layoutId: "",
//                 layoutIdError: "",
//               })),
//               previewImage: null,
//               thumbnailImage: null,
//             });
//           }
//         );
//       } else {
//         // No sizeId yet — just update and regenerate filenames if any slots have files
//         this.setState({ [name]: value || "", [`${name}Error`]: "" }, () => {
//           const hasFiles = this.state.templateImages.some((s) => s.file);
//           if (hasFiles) {
//             this.setState((prev) => ({
//               templateImages: prev.templateImages.map((slot) => {
//                 if (!slot.file) return slot;
//                 const generatedName = this.generateAssetFileName(slot);
//                 const renamedFile = new File([slot.file], generatedName, { type: slot.file.type });
//                 return { ...slot, file: renamedFile, generatedFileName: generatedName };
//               }),
//             }));
//           }
//         });
//       }
//       return;
//     }

//     // ── Theme Label change — regenerate filenames live; warn+clear only if files are uploaded ──
//     if (name === "themeLabel") {
//       if (this.state.templateImages.some((s) => s.file)) {
//         this.confirmReset(
//           "Changing the theme label will reset all uploaded images. Continue?",
//           () => {
//             this.setState({
//               [name]: value || "",
//               [`${name}Error`]: "",
//               // Keep slot structure intact — only clear uploaded file data
//               templateImages: this.state.templateImages.map((slot) => ({
//                 ...slot,
//                 file: null,
//                 preview: null,
//                 dimensions: null,
//                 generatedFileName: "",
//               })),
//               previewImage: null,
//               thumbnailImage: null,
//             });
//           }
//         );
//       } else {
//         // No files yet — update label and regenerate any filenames if slots exist
//         this.setState({ [name]: value || "", [`${name}Error`]: "" }, () => {
//           const hasFiles = this.state.templateImages.some((s) => s.file);
//           if (hasFiles) {
//             this.setState((prev) => ({
//               templateImages: prev.templateImages.map((slot) => {
//                 if (!slot.file) return slot;
//                 const generatedName = this.generateAssetFileName(slot);
//                 const renamedFile = new File([slot.file], generatedName, { type: slot.file.type });
//                 return { ...slot, file: renamedFile, generatedFileName: generatedName };
//               }),
//             }));
//           }
//         });
//       }
//       return;
//     }

//     // ── Size change — warn only if templateImages have uploaded files ──
//     if (name === "sizeId") {
//       if (this.state.templateImages.some((s) => s.file)) {
//         this.confirmReset(
//           "Changing the size will reset all uploaded images. Continue?",
//           () => {
//             this.setState({
//               [name]: value || "",
//               [`${name}Error`]: "",
//               totalPages: "",
//               totalPagesError: "",
//               selectedProductTypes: [],
//               selectedProductTypesError: "",
//               selectedBundles: [],
//               selectedBundlesError: "",
//               templateImages: this.state.templateImages.map((slot) => ({
//                 ...slot,
//                 file: null,
//                 preview: null,
//                 dimensions: null,
//                 generatedFileName: "",
//               })),
//               previewImage: null,
//               thumbnailImage: null,
//             });
//           }
//         );
//       } else {
//         // No uploaded files — just update sizeId and regenerate any existing filenames
//         this.setState({ [name]: value || "", [`${name}Error`]: "" }, () => {
//           const hasFiles = this.state.templateImages.some((s) => s.file);
//           if (hasFiles) {
//             this.setState((prev) => ({
//               templateImages: prev.templateImages.map((slot) => {
//                 if (!slot.file) return slot;
//                 const generatedName = this.generateAssetFileName(slot);
//                 const renamedFile = new File([slot.file], generatedName, { type: slot.file.type });
//                 return { ...slot, file: renamedFile, generatedFileName: generatedName };
//               }),
//             }));
//           }
//         });
//       }
//       return;
//     }

//     // ── Default ──
//     this.setState({
//       [name]: value || "",
//       [`${name}Error`]: "",
//     });
//   };
//   // handleChange = (e) => {
//   //   const { name, value } = e.target;
//   //   this.setState({
//   //     [name]: value || "",
//   //     [`${name}Error`]: "",
//   //   }, () => {
//   //     if (name === "categoryId" && value) {
//   //       // Reset all dependent state
//   //       this.setState({
//   //         themeCategoryId: "",
//   //         themeCategoryIdError: "",
//   //         sizeId: "",
//   //         sizeIdError: "",
//   //         totalPages: "",
//   //         totalPagesError: "",
//   //         selectedProductTypes: [],
//   //         selectedProductTypesError: "",
//   //         selectedBundles: [],
//   //         selectedBundlesError: "",
//   //         bundlesList: [],
//   //         sizesList: [],
//   //         productTypesList: [],
//   //         themeLabel: "",
//   //         themeLabelError: "",
//   //         description: "",
//   //         descriptionError: "",
//   //         templateImages: [],
//   //         previewImage: null,
//   //         previewImageError: "",
//   //         thumbnailImage: null,
//   //         thumbnailImageError: "",
//   //       });

//   //       // Fetch dependent data
//   //       this.fetchSizes(value);
//   //       this.fetchProductTypes(value);
//   //       this.fetchBundles(value);
//   //       this.buildTotalPagesList(value);
//   //       this.buildTemplateSlots(value);
//   //       this.fetchLayouts(value);
//   //     }
//   //   });
//   // };

//   handleProductTypesChange = (selected) => {
//     this.setState({
//       selectedProductTypes: selected || [],
//       selectedProductTypesError: "",
//     });
//   };

//   handleBundlesChange = (selected) => {
//     this.setState({
//       selectedBundles: selected || [],
//       selectedBundlesError: "",
//     });
//   };

//   handleSnackbar = (isOpen, message, severity) => {
//     this.setState({ isOpenSnackbar: isOpen, snackbarMessage: message, snackbarSeverity: severity });
//   };


//   handleTemplateImageUpload = (slotKey, file) => {
//     if (!file) return;
//     const preview = URL.createObjectURL(file);

//     const img = new Image();
//     img.onload = () => {
//       // ── Aspect ratio validation ──
//       const { sizesList, sizeId, categoryId, templateImages } = this.state;
//       const sizeItem = sizesList.find((s) => s.id == sizeId);
//       const sizeLabel = sizeItem?.label || sizeItem?.userLabel || "";
//       const slot = templateImages.find((s) => s.slotKey === slotKey);
//       const expectedRatio = slot
//         ? getExpectedAspectRatio(sizeId, slot.pageNumber, slot.slotNumber, categoryId)
//         : null;

//       if (expectedRatio) {
//         const actualRatio = img.width / img.height;
//         const diff = Math.abs(actualRatio - expectedRatio);
//         if (diff > ASPECT_RATIO_TOLERANCE) {
//           URL.revokeObjectURL(preview);
//           this.handleSnackbar(
//             true,
//             `Wrong aspect ratio for slot ${slotKey}. ` +
//             `Expected ~${expectedRatio.toFixed(4)} (±${ASPECT_RATIO_TOLERANCE}), ` +
//             `got ${actualRatio.toFixed(4)} (${img.width}×${img.height}px).`,
//             "error"
//           );
//           return;
//         }
//       }

//       this.setState((prev) => ({
//         templateImages: prev.templateImages.map((slot) => {
//           if (slot.slotKey !== slotKey) return slot;
//           const updatedSlot = {
//             ...slot,
//             file,
//             preview,
//             dimensions: { width: img.width, height: img.height },
//           };
//           // Generate name after slot is updated
//           return updatedSlot;
//         }),
//       }), () => {
//         // Re-generate filename after state is updated (so layoutId etc are current)
//         this.setState((prev) => ({
//           templateImages: prev.templateImages.map((slot) => {
//             if (slot.slotKey !== slotKey) return slot;
//             const generatedName = this.generateAssetFileName(slot);
//             const renamedFile = new File([slot.file], generatedName, { type: slot.file.type });
//             return { ...slot, file: renamedFile, generatedFileName: generatedName };
//           }),
//         }));
//       });
//     };
//     img.src = preview;
//   };

//   handleTemplateImageRemove = (slotKey) => {
//     this.setState((prev) => ({
//       templateImages: prev.templateImages.map((slot) =>
//         slot.slotKey === slotKey ? { ...slot, file: null, preview: null } : slot
//       ),
//     }));
//   };


//   // Returns { collageInfoList, exportWidth, exportHeight } using actual pixel export dimensions
//   getCollageOverlay = (layoutId, pageNumber) => {
//     const { sizesList, sizeId, layoutsList, categoryId } = this.state;
//     if (!layoutId) return null;

//     const sizeItem = sizesList.find((s) => s.id == sizeId);
//     const sizeAlias = sizeItem?.alias || sizeItem?.userLabel?.toLowerCase().replace(/\s+/g, "") || "ml";

//     const layoutItem = layoutsList.find((l) => String(l.layoutId) === String(layoutId));
//     if (!layoutItem) return null;
//     const layoutNo = (layoutItem.layoutNo || "").replace(/\s+/g, "");

//     const fnName = `${sizeAlias}_${layoutNo}`;
//     if (typeof this[fnName] !== "function") return null;

//     // Derive real export pixel dimensions from the same source as getExpectedAspectRatio
//     const id = parseInt(categoryId);
//     const totalPages = { 2: 24, 6: 12, 9: 1 }[id] || 0;
//     const isFrontCover = pageNumber === 1;
//     const isBackCover = pageNumber === totalPages && totalPages > 1;
//     const isRightPage = totalPages > 1 && pageNumber % 2 === 0;

//     let exportW = 3508, exportH = 2400; // sensible default (landscape inner)

//     if (id === 2) {
//       if (sizeItem?.id == 2) {
//         if (isFrontCover) { exportW = 3796; exportH = 3000; }
//         else if (isBackCover) { exportW = 4010; exportH = 3000; }
//         else { exportW = 3508; exportH = 2400; }
//       } else if (sizeItem?.id == 4) {
//         if (isFrontCover) { exportW = 2737; exportH = 3000; }
//         else if (isBackCover) { exportW = 2961; exportH = 3000; }
//         else { exportW = 2400; exportH = 2400; }
//       }
//     } else if (id === 6) {
//       if (sizeItem?.id === 15) { exportW = 3600; exportH = 3600; }
//       else { exportW = 3600; exportH = 5400; }
//     } else if (id === 9) {
//       exportW = 2550;
//       exportH = sizeItem?.id === 23 ? 1125 : 1050;
//     }

//     const collageInfoList = this[fnName]({ exportWidth: exportW, exportHeight: exportH, isRightPage });
//     return { collageInfoList, exportWidth: exportW, exportHeight: exportH };
//   };



//   isFormValid = () => {
//     let isValid = true;
//     const errors = {};

//     if (!this.state.categoryId) {
//       isValid = false;
//       errors.categoryIdError = "Please select a category.";
//     }
//     if (!this.state.themeCategoryId) {
//       isValid = false;
//       errors.themeCategoryIdError = "Please select a theme category.";
//     }
//     if (!this.state.sizeId) {
//       isValid = false;
//       errors.sizeIdError = "Please select a size.";
//     }
//     if (!this.state.totalPages) {
//       isValid = false;
//       errors.totalPagesError = "Please select total pages.";
//     }
//     if (!this.state.selectedProductTypes || this.state.selectedProductTypes.length === 0) {
//       isValid = false;
//       errors.selectedProductTypesError = "Please select at least one product type.";
//     }
//     if (!this.state.themeLabel) {
//       isValid = false;
//       errors.themeLabelError = "Please enter theme label.";
//     }
//     if (!this.state.description) {
//       isValid = false;
//       errors.descriptionError = "Please enter description.";
//     }

//     // Preview — required for all
//     if (!this.state.previewImage) {
//       isValid = false;
//       errors.previewImageError = "Please upload preview image.";
//     }

//     // Thumbnail — required for Calendar only
//     if (this.state.categoryId == 6 && !this.state.thumbnailImage) {
//       isValid = false;
//       errors.thumbnailImageError = "Please upload thumbnail image.";
//     }

//     // Validate all template image slots are filled
//     const emptySlots = this.state.templateImages.filter((slot) => !slot.file);
//     if (emptySlots.length > 0) {
//       isValid = false;
//       this.handleSnackbar(
//         true,
//         `Please upload all template images. ${emptySlots.length} slot(s) are empty: ${emptySlots.map((s) => `Page ${s.pageNumber} - ${s.slotLabel}`).join(", ")}`,
//         "error"
//       );
//     }

//     const emptyLayouts = this.state.templateImages.filter((slot) => !slot.layoutId);
//     if (emptyLayouts.length > 0) {
//       isValid = false;
//       this.handleSnackbar(
//         true,
//         `Please select layout for all slots. ${emptyLayouts.length} slot(s) missing: ${emptyLayouts.map((s) => `Page ${s.pageNumber} - ${s.slotLabel}`).join(", ")}`,
//         "error"
//       );
//     }

//     this.setState(errors);
//     return isValid;
//   };

//   submitForm = async (e) => {
//     e.preventDefault();
//     if (!this.isFormValid()) return;

//     this.setState({ isLoading: true });

//     const data = new FormData();
//     data.append("recordId", this.state.recordId);
//     data.append("categoryId", this.state.categoryId);
//     data.append("themeCategoryId", this.state.themeCategoryId);
//     data.append("sizeId", this.state.sizeId);
//     data.append("totalPages", this.state.totalPages);
//     data.append("themeLabel", this.state.themeLabel);
//     data.append("description", this.state.description);



//     // Product Types — list
//     this.state.selectedProductTypes.forEach((pt) => {
//       data.append("productTypeId", pt.id);
//     });

//     // Bundles — list
//     this.state.selectedBundles && this.state.selectedBundles.forEach((b) => {
//       data.append("bundleId", b.id);
//     });

//     // Template Images — split into AppAssets and PrintAssets
//     const appAssets = this.state.templateImages.filter((s) => s.slotNumber === 1);
//     const printAssets = this.state.templateImages.filter((s) => s.slotNumber === 2);

//     appAssets.forEach((slot) => {
//       data.append("appAssets", slot.file);
//       data.append("appAssetLayoutIds", slot.layoutId);
//     });

//     printAssets.forEach((slot) => {
//       data.append("printAssets", slot.file);
//       data.append("printAssetLayoutIds", slot.layoutId);
//     });

//     // Preview image — required for all categories
//     if (this.state.previewImage) {
//       data.append("previewFile", this.state.previewImage.file);
//     }

//     // Thumbnail image — Calendar only
//     if (this.state.categoryId == 6 && this.state.thumbnailImage) {
//       data.append("thumbnailFile", this.state.thumbnailImage.file);
//     }

//     const res = await HttpRequest(
//       "POST",
//       `${process.env.REACT_APP_API_DOMAIN}/${process.env.REACT_APP_SUB_API_NAME}/common/C15ALLThemesSave`,
//       data,
//       "authorize"
//     );

//     if (res.isSuccess) {
//       this.handleSnackbar(true, "Saved Successfully", "success");
//       this.clearForm();
//     } else {
//       if (res.statusCode === 401) this.setState({ isLoginMenu: true });
//       else this.handleSnackbar(true, res.message || "Save failed", "error");
//     }

//     this.setState({ isLoading: false });
//   };

//   getGeneratedLabel = () => {
//     const { themeLabel, sizesList, sizeId, selectedProductTypes, selectedBundles, categoryId, categoriesList } = this.state;

//     if (!themeLabel) return "";

//     const sizeItem = sizesList.find((s) => s.id == sizeId);
//     const sizeLabel = sizeItem ? (sizeItem.label || sizeItem.userLabel || "") : "";

//     const labels = [];

//     const bundlesExcludingOne = selectedBundles
//       ? selectedBundles.filter((b) => b.value !== 1)
//       : [];

//     const hasBundleOf1 = selectedBundles
//       ? selectedBundles.some((b) => b.value === 1)
//       : false;

//     // ── Calendar: use category label instead of product type ──
//     if (categoryId == 6) {
//       const categoryItem = categoriesList.find((c) => c.id == categoryId);
//       const categoryLabel = categoryItem ? (categoryItem.label || categoryItem.userLabel || "") : "";

//       let base = `${themeLabel} Theme`;
//       if (sizeLabel) base += ` - ${sizeLabel}`;
//       if (categoryLabel) base += ` - ${categoryLabel}`;

//       if (bundlesExcludingOne.length === 0) {
//         labels.push(base);
//       } else if (hasBundleOf1) {
//         labels.push(base);
//         bundlesExcludingOne.forEach((bundle) => {
//           labels.push(`${base} - ${bundle.label}`);
//         });
//       } else {
//         bundlesExcludingOne.forEach((bundle) => {
//           labels.push(`${base} - ${bundle.label}`);
//         });
//       }

//       return labels.join("\n");
//     }

//     // ── All other categories: use product types ──
//     const productTypes = selectedProductTypes && selectedProductTypes.length > 0
//       ? selectedProductTypes
//       : [null];

//     productTypes.forEach((pt) => {
//       let base = `${themeLabel} Theme`;
//       if (sizeLabel) base += ` - ${sizeLabel}`;
//       if (pt) base += ` - ${pt.label}`;

//       if (bundlesExcludingOne.length === 0) {
//         labels.push(base);
//       } else if (hasBundleOf1) {
//         labels.push(base);
//         bundlesExcludingOne.forEach((bundle) => {
//           labels.push(`${base} - ${bundle.label}`);
//         });
//       } else {
//         bundlesExcludingOne.forEach((bundle) => {
//           labels.push(`${base} - ${bundle.label}`);
//         });
//       }
//     });

//     return labels.join("\n");
//   };


//   handleReplicatePage1ToAll = () => {
//     const page1AppAsset = this.state.templateImages.find(
//       (s) => s.pageNumber === 1 && s.slotNumber === 1
//     );
//     const page1PrintAsset = this.state.templateImages.find(
//       (s) => s.pageNumber === 1 && s.slotNumber === 2
//     );

//     if (!page1AppAsset?.file || !page1PrintAsset?.file) {
//       this.handleSnackbar(true, "Please upload both Page 1 images first.", "error");
//       return;
//     }

//     this.setState((prev) => ({
//       templateImages: prev.templateImages.map((slot) => {
//         if (slot.pageNumber === 1) return slot; // keep page 1 as is

//         if (slot.slotNumber === 1) {
//           // Replicate App Asset
//           return {
//             ...slot,
//             file: page1AppAsset.file,
//             preview: page1AppAsset.preview,
//             dimensions: page1AppAsset.dimensions,
//           };
//         } else {
//           // Replicate Print Asset
//           return {
//             ...slot,
//             file: page1PrintAsset.file,
//             preview: page1PrintAsset.preview,
//             dimensions: page1PrintAsset.dimensions,
//           };
//         }
//       }),
//     }), () => {
//       this.handleSnackbar(true, "Page 1 images replicated to all pages successfully.", "success");
//     });
//   };


//   clearForm = () => {
//     this.setState({
//       recordId: 0,
//       categoryId: "",
//       categoryIdError: "",
//       themeCategoryId: "",
//       themeCategoryIdError: "",
//       sizeId: "",
//       sizeIdError: "",
//       totalPages: "",
//       totalPagesError: "",
//       selectedProductTypes: [],
//       selectedProductTypesError: "",
//       bundleId: "",
//       bundleIdError: "",
//       description: "",
//       descriptionError: "",
//       themeLabel: "",
//       themeLabelError: "",
//       previewImage: null,        // { file, preview, dimensions }
//       previewImageError: "",
//       thumbnailImage: null,      // { file, preview, dimensions }
//       thumbnailImageError: "",
//       templateImages: [],
//     });
//   };

//   handlePreviewImageUpload = (file) => {
//     if (!file) return;
//     const preview = URL.createObjectURL(file);
//     const img = new Image();
//     img.onload = () => {
//       this.setState({
//         previewImage: { file, preview, dimensions: { width: img.width, height: img.height } },
//         previewImageError: "",
//       });
//     };
//     img.src = preview;
//   };

//   handleThumbnailImageUpload = (file) => {
//     if (!file) return;
//     const preview = URL.createObjectURL(file);
//     const img = new Image();
//     img.onload = () => {
//       this.setState({
//         thumbnailImage: { file, preview, dimensions: { width: img.width, height: img.height } },
//         thumbnailImageError: "",
//       });
//     };
//     img.src = preview;
//   };

//   handlePreviewImageRemove = () => {
//     this.setState({ previewImage: null, previewImageError: "" });
//   };

//   handleThumbnailImageRemove = () => {
//     this.setState({ thumbnailImage: null, thumbnailImageError: "" });
//   };

//   onViewAllButtonClick = () => {
//     window.location = "#/F15AllThemedAssetsView";
//   };


//   generateAssetFileName = (slot) => {

//     console.log("generateAssetFileName called for slot:", slot.slotKey);
//     console.log("slot.layoutId:", slot.layoutId);
//     const {
//       categoryId, sizeId, themeLabel,
//       themeCategoryId, categoriesList, sizesList, themeCategoriesList, layoutsList,
//     } = this.state;

//     const pageNo = slot.pageNumber;
//     const assetTypePrefix = slot.slotNumber === 1 ? "ic" : "fl";

//     const categoryItem = categoriesList.find((c) => c.id == categoryId);
//     const categoryAlias = categoryItem?.alias || "pb";

//     const sizeItem = sizesList.find((s) => s.id == sizeId);
//     const sizeAlias = sizeItem?.alias || sizeItem?.userLabel?.toLowerCase().replace(/\s+/g, "") || "ml";

//     const themeCategoryItem = themeCategoriesList.find((t) => (t.categoryId || t.id) == themeCategoryId);
//     const themeCategoryLabel = (themeCategoryItem?.categoryLabel || themeCategoryItem?.label || "")
//       .toLowerCase()
//       .replace(/\s+/g, "")
//       .replace(/[^a-z0-9]/g, "");

//     const cleanThemeLabel = (themeLabel || "")
//       .toLowerCase()
//       .replace(/\s+/g, "")
//       .replace(/[^a-z0-9]/g, "");

//     // ── Use slot.layoutId directly (not from state loop) ──
//     const layoutItem = layoutsList.find((l) => String(l.layoutId) === String(slot.layoutId));
//     const layoutNo = layoutItem?.layoutNo || "0";

//     console.log("layoutItem:", layoutItem);
//     console.log("layoutNo:", layoutNo);

//     // const ext = slot.file?.name?.split(".").pop() || "png";
//     const mimeToExt = { "image/png": "png", "image/jpeg": "jpg", "image/jpg": "jpg", "image/gif": "gif" };
//     const ext = mimeToExt[slot.file?.type] || "png";

//     return `${pageNo}_${assetTypePrefix}_tm_${categoryAlias}_${sizeAlias}_${themeCategoryLabel}_${cleanThemeLabel}_${layoutNo}.${ext}`;
//   };

//   confirmReset = (message, onConfirm) => {
//     if (window.confirm(message)) {
//       onConfirm();
//     }
//   };

//   render() {
//     const { classes } = this.props;
//     const {
//       categoriesList, themeCategoriesList, sizesList,
//       totalPagesList, productTypesList, bundlesList,
//       selectedProductTypes,
//     } = this.state;

//     return (
//       <Fragment>
//         <LoginMenu
//           reload={this.state.isReload}
//           open={this.state.isLoginMenu}
//           handleClose={() => this.setState({ isLoginMenu: false })}
//         />
//         <CustomizedSnackbar
//           isOpen={this.state.isOpenSnackbar}
//           message={this.state.snackbarMessage}
//           severity={this.state.snackbarSeverity}
//           handleCloseSnackbar={() => this.handleSnackbar(false, "", "")}
//           autoHideDuration={3000}
//         />

//         <Grid
//           container
//           xs={12}
//           direction="column"
//           justifyContent="center"
//           alignItems="center"
//           style={{ padding: 10 }}
//         >
//           <Toolbar>
//             <NavBar isAuthorize title="Add New Theme" />
//           </Toolbar>

//           <Card
//             style={{
//               width: "98%",
//               paddingBottom: 100,
//               paddingLeft: 20,
//               paddingRight: 20,
//             }}
//           >
//             <CardContent>
//               <Typography variant="h5" color="primary" style={{ fontWeight: 700, marginBottom: 8 }}>
//                 {this.state.recordId == 0 ? "Add New Theme" : "Edit Theme"}
//               </Typography>
//               <Divider style={{ marginBottom: 24 }} />

//               <Grid container spacing={2}>

//                 {/* ── Category ── */}
//                 <Grid item xs={12} sm={6}>
//                   <TextField
//                     select
//                     id="categoryId"
//                     name="categoryId"
//                     fullWidth
//                     label="Category *"
//                     variant="outlined"
//                     onChange={this.handleChange}
//                     value={this.state.categoryId}
//                     error={!!this.state.categoryIdError}
//                     helperText={this.state.categoryIdError}
//                     disabled={this.state.categoriesLoading}
//                     size="small"
//                   >
//                     {categoriesList.map((item) => (
//                       <MenuItem key={item.id} value={item.id}>
//                         {item.label || item.userLabel || ""}
//                       </MenuItem>
//                     ))}
//                   </TextField>
//                 </Grid>

//                 {/* ── Theme Category ── */}
//                 <Grid item xs={12} sm={6}>
//                   <TextField
//                     select
//                     id="themeCategoryId"
//                     name="themeCategoryId"
//                     fullWidth
//                     label="Theme Category *"
//                     variant="outlined"
//                     onChange={this.handleChange}
//                     value={this.state.themeCategoryId}
//                     error={!!this.state.themeCategoryIdError}
//                     helperText={this.state.themeCategoryIdError}
//                     disabled={this.state.themeCategoriesLoading}
//                     size="small"
//                   >
//                     {themeCategoriesList.map((item) => {
//                       const isDisabled = [2, 6].includes(parseInt(this.state.categoryId)) && item.id === 3;
//                       return (
//                         <MenuItem key={item.id} value={item.id} disabled={isDisabled}>
//                           {item.categoryLabel || item.label || ""}{isDisabled ? " (Not available for this category)" : ""}
//                         </MenuItem>
//                       );
//                     })}
//                   </TextField>
//                 </Grid>
//                 {/* ── Theme Label ── */}
//                 <Grid item xs={12} sm={6}>
//                   <TextField
//                     autoComplete="off"
//                     id="themeLabel"
//                     name="themeLabel"
//                     label="Theme Label *"
//                     variant="outlined"
//                     onChange={this.handleChange}
//                     value={this.state.themeLabel}
//                     error={!!this.state.themeLabelError}
//                     helperText={this.state.themeLabelError}
//                     fullWidth
//                     inputProps={{ maxLength: 250 }}
//                     size="small"
//                   />
//                 </Grid>

//                 {/* ── Size ── */}
//                 <Grid item xs={12} sm={6}>
//                   <TextField
//                     select
//                     id="sizeId"
//                     name="sizeId"
//                     fullWidth
//                     label="Size *"
//                     variant="outlined"
//                     onChange={this.handleChange}
//                     value={this.state.sizeId}
//                     error={!!this.state.sizeIdError}
//                     helperText={this.state.sizeIdError}
//                     disabled={this.state.sizesLoading}
//                     size="small"
//                   >
//                     {sizesList.map((item) => (
//                       <MenuItem key={item.id} value={item.id}>
//                         {item.label || item.userLabel || ""}
//                       </MenuItem>
//                     ))}
//                   </TextField>
//                 </Grid>



//                 {/* ── Product Type (Multi-select) ── */}
//                 <Grid item xs={12} sm={6}>

//                   <Select
//                     isMulti
//                     value={selectedProductTypes}
//                     name="productTypesList"
//                     options={productTypesList}
//                     onChange={this.handleProductTypesChange}
//                     className="basic-multi-select"
//                     size="small"
//                     classNamePrefix="select"
//                     placeholder="Select product types..."
//                     isLoading={this.state.productTypesLoading}
//                     styles={{
//                       option: (base) => ({
//                         ...base,
//                         background: "#FFFFFF",
//                         backgroundColor: "#FFFFFF",
//                       }),
//                       control: (base) => ({
//                         ...base,
//                         borderColor: this.state.selectedProductTypesError ? "#f44336" : base.borderColor,
//                         minHeight: 56,
//                       }),
//                     }}
//                   />
//                   {this.state.selectedProductTypesError && (
//                     <Typography variant="caption" style={{ color: "#f44336", marginTop: 4, display: "block" }}>
//                       {this.state.selectedProductTypesError}
//                     </Typography>
//                   )}
//                 </Grid>

//                 {/* ── Bundles ── */}
//                 {this.state.categoryId == 9 && (
//                   <Grid item xs={12} sm={6}>

//                     <Select
//                       isMulti
//                       value={this.state.selectedBundles}
//                       name="bundlesList"
//                       options={this.state.bundlesList}
//                       onChange={this.handleBundlesChange}
//                       className="basic-multi-select"
//                       classNamePrefix="select"
//                       placeholder="Select bundles..."
//                       isLoading={this.state.bundlesLoading}
//                       styles={{
//                         option: (base) => ({
//                           ...base,
//                           background: "#FFFFFF",
//                           backgroundColor: "#FFFFFF",
//                         }),
//                         control: (base) => ({
//                           ...base,
//                           borderColor: this.state.selectedBundlesError ? "#f44336" : base.borderColor,
//                           minHeight: 56,
//                         }),
//                       }}
//                     />
//                     {this.state.selectedBundlesError && (
//                       <Typography variant="caption" style={{ color: "#f44336", marginTop: 4, display: "block" }}>
//                         {this.state.selectedBundlesError}
//                       </Typography>
//                     )}
//                   </Grid>
//                 )}


//                 {/* ── Description ── */}
//                 <Grid item xs={12} sm={6}>
//                   <TextField
//                     autoComplete="off"
//                     id="description"
//                     name="description"
//                     label="Description *"
//                     variant="outlined"
//                     onChange={this.handleChange}
//                     value={this.state.description}
//                     error={!!this.state.descriptionError}
//                     helperText={this.state.descriptionError}
//                     fullWidth
//                     multiline
//                     rows={2}
//                     inputProps={{ maxLength: 500 }}
//                     size="small"
//                   />
//                 </Grid>

//                 {/* ── PREVIEW & THUMBNAIL IMAGES ── */}
//                 {this.state.categoryId && (
//                   <Grid item xs={12}>
//                     <Divider style={{ margin: "16px 0" }} />
//                     <Typography variant="h6" color="primary" style={{ fontWeight: 600, marginBottom: 16 }}>
//                       {this.state.categoryId == 6 ? "Preview & Thumbnail Images" : "Preview Image"}
//                     </Typography>

//                     <Grid container spacing={2}>

//                       {/* ── Preview Image — required for all categories ── */}
//                       <Grid item xs={12} sm={6} md={4}>
//                         <Typography
//                           variant="subtitle2"
//                           style={{ fontWeight: 600, color: "#555", marginBottom: 8 }}
//                         >
//                           Preview Image <span style={{ color: "#f44336" }}>*</span>
//                         </Typography>

//                         <input
//                           type="file"
//                           accept="image/*"
//                           id="preview-image-upload"
//                           style={{ display: "none" }}
//                           onChange={(e) => {
//                             const file = e.target.files[0];
//                             if (file) this.handlePreviewImageUpload(file);
//                             e.target.value = "";
//                           }}
//                         />

//                         <label htmlFor="preview-image-upload" style={{ cursor: "pointer", display: "block" }}>
//                           <Tooltip title={this.state.previewImage ? "Click to replace" : "Click to upload"}>
//                             <div
//                               style={{
//                                 width: "100%",
//                                 height: 180,
//                                 backgroundColor: "#f5f5f5",
//                                 border: this.state.previewImage
//                                   ? "1px solid #e0e0e0"
//                                   : this.state.previewImageError
//                                     ? "2px dashed #f44336"
//                                     : "2px dashed #ccc",
//                                 borderRadius: 8,
//                                 overflow: "hidden",
//                                 display: "flex",
//                                 alignItems: "center",
//                                 justifyContent: "center",
//                                 transition: "opacity 0.2s",
//                               }}
//                               onMouseEnter={(e) => e.currentTarget.style.opacity = "0.85"}
//                               onMouseLeave={(e) => e.currentTarget.style.opacity = "1"}
//                             >
//                               {this.state.previewImage ? (
//                                 <img
//                                   src={this.state.previewImage.preview}
//                                   alt="preview"
//                                   style={{ width: "100%", height: "100%", objectFit: "contain" }}
//                                 />
//                               ) : (
//                                 <div style={{ textAlign: "center", color: "#bbb" }}>
//                                   <img src={ckLogo} alt="preview" style={{ width: "20%", height: "20%", objectFit: "contain" }} />
//                                   <Typography variant="caption" style={{ color: "#bbb", display: "block", marginTop: 4 }}>
//                                     Click to upload Preview
//                                   </Typography>
//                                 </div>
//                               )}
//                             </div>
//                           </Tooltip>
//                         </label>

//                         {this.state.previewImage && (
//                           <Box mt={1}>
//                             <Typography
//                               variant="caption"
//                               color="textSecondary"
//                               style={{
//                                 display: "block",
//                                 whiteSpace: "nowrap",
//                                 overflow: "hidden",
//                                 textOverflow: "ellipsis",
//                               }}
//                               title={this.state.previewImage.file.name}
//                             >
//                               📄 {this.state.previewImage.file.name}
//                             </Typography>
//                             {this.state.previewImage.dimensions && (
//                               <Typography variant="caption" style={{ color: "#888", display: "block" }}>
//                                 📐 {this.state.previewImage.dimensions.width} × {this.state.previewImage.dimensions.height} px
//                               </Typography>
//                             )}
//                             <Box display="flex" justifyContent="flex-end">
//                               <Tooltip title="Remove">
//                                 <IconButton
//                                   size="small"
//                                   onClick={this.handlePreviewImageRemove}
//                                   style={{ color: "#f44336", padding: 4 }}
//                                 >
//                                   <CloseIcon fontSize="small" />
//                                 </IconButton>
//                               </Tooltip>
//                             </Box>
//                           </Box>
//                         )}

//                         {this.state.previewImageError && (
//                           <Typography variant="caption" style={{ color: "#f44336", display: "block", marginTop: 4 }}>
//                             {this.state.previewImageError}
//                           </Typography>
//                         )}
//                       </Grid>

//                       {/* ── Thumbnail Image — Calendar only ── */}
//                       {this.state.categoryId == 6 && (
//                         <Grid item xs={12} sm={6} md={4}>
//                           <Typography
//                             variant="subtitle2"
//                             style={{ fontWeight: 600, color: "#555", marginBottom: 8 }}
//                           >
//                             Thumbnail Image <span style={{ color: "#f44336" }}>*</span>
//                           </Typography>

//                           <input
//                             type="file"
//                             accept="image/*"
//                             id="thumbnail-image-upload"
//                             style={{ display: "none" }}
//                             onChange={(e) => {
//                               const file = e.target.files[0];
//                               if (file) this.handleThumbnailImageUpload(file);
//                               e.target.value = "";
//                             }}
//                           />

//                           <label htmlFor="thumbnail-image-upload" style={{ cursor: "pointer", display: "block" }}>
//                             <Tooltip title={this.state.thumbnailImage ? "Click to replace" : "Click to upload"}>
//                               <div
//                                 style={{
//                                   width: "100%",
//                                   height: 180,
//                                   backgroundColor: "#f5f5f5",
//                                   border: this.state.thumbnailImage
//                                     ? "1px solid #e0e0e0"
//                                     : this.state.thumbnailImageError
//                                       ? "2px dashed #f44336"
//                                       : "2px dashed #ccc",
//                                   borderRadius: 8,
//                                   overflow: "hidden",
//                                   display: "flex",
//                                   alignItems: "center",
//                                   justifyContent: "center",
//                                   transition: "opacity 0.2s",
//                                 }}
//                                 onMouseEnter={(e) => e.currentTarget.style.opacity = "0.85"}
//                                 onMouseLeave={(e) => e.currentTarget.style.opacity = "1"}
//                               >
//                                 {this.state.thumbnailImage ? (
//                                   <img
//                                     src={this.state.thumbnailImage.preview}
//                                     alt="thumbnail"
//                                     style={{ width: "100%", height: "100%", objectFit: "contain" }}
//                                   />
//                                 ) : (
//                                   <div style={{ textAlign: "center", color: "#bbb" }}>
//                                     <img src={ckLogo} alt="preview" style={{ width: "20%", height: "20%", objectFit: "contain" }} />
//                                     <Typography variant="caption" style={{ color: "#bbb", display: "block", marginTop: 4 }}>
//                                       Click to upload Thumbnail
//                                     </Typography>
//                                   </div>
//                                 )}
//                               </div>
//                             </Tooltip>
//                           </label>

//                           {this.state.thumbnailImage && (
//                             <Box mt={1}>
//                               <Typography
//                                 variant="caption"
//                                 color="textSecondary"
//                                 style={{
//                                   display: "block",
//                                   whiteSpace: "nowrap",
//                                   overflow: "hidden",
//                                   textOverflow: "ellipsis",
//                                 }}
//                                 title={this.state.thumbnailImage.file.name}
//                               >
//                                 📄 {this.state.thumbnailImage.file.name}
//                               </Typography>
//                               {this.state.thumbnailImage.dimensions && (
//                                 <Typography variant="caption" style={{ color: "#888", display: "block" }}>
//                                   📐 {this.state.thumbnailImage.dimensions.width} × {this.state.thumbnailImage.dimensions.height} px
//                                 </Typography>
//                               )}
//                               <Box display="flex" justifyContent="flex-end">
//                                 <Tooltip title="Remove">
//                                   <IconButton
//                                     size="small"
//                                     onClick={this.handleThumbnailImageRemove}
//                                     style={{ color: "#f44336", padding: 4 }}
//                                   >
//                                     <CloseIcon fontSize="small" />
//                                   </IconButton>
//                                 </Tooltip>
//                               </Box>
//                             </Box>
//                           )}

//                           {this.state.thumbnailImageError && (
//                             <Typography variant="caption" style={{ color: "#f44336", display: "block", marginTop: 4 }}>
//                               {this.state.thumbnailImageError}
//                             </Typography>
//                           )}
//                         </Grid>
//                       )}
//                     </Grid>
//                   </Grid>
//                 )}

//                 {/* ── Generated Label Preview ── */}
//                 {(() => {
//                   const generatedLabel = this.getGeneratedLabel();
//                   if (!generatedLabel) return null;
//                   return (
//                     <Grid item xs={12}>
//                       <TextField
//                         label="Generated Product Label(s)"
//                         variant="outlined"
//                         fullWidth
//                         size="small"
//                         multiline
//                         value={generatedLabel}
//                         InputProps={{ readOnly: true }}
//                         inputProps={{ style: { color: "#333", fontFamily: "monospace", fontSize: 13 } }}
//                         helperText={`${generatedLabel.split("\n").length} label(s) will be generated`}
//                       />
//                     </Grid>
//                   );
//                 })()}


//                 {/* ── IMAGE TEMPLATE ── */}
//                 {/* ── IMAGE TEMPLATE ── */}
//                 {this.state.templateImages.length > 0 && (
//                   <Grid item xs={12}>
//                     <Divider style={{ margin: "16px 0" }} />
//                     <Box display="flex" alignItems="center" justifyContent="space-between" mb={2}>
//                       <Typography variant="h6" color="primary" style={{ fontWeight: 600 }}>
//                         Theme Image Template
//                         <span style={{ fontSize: 13, color: "#888", fontWeight: 400, marginLeft: 8 }}>
//                           ({this.state.templateImages.length} images — 2 per page)
//                         </span>
//                       </Typography>

//                       {/* ── Replicate Button — Calendar only ── */}
//                       {this.state.categoryId == 6 && (() => {
//                         const page1App = this.state.templateImages.find(
//                           (s) => s.pageNumber === 1 && s.slotNumber === 1
//                         );
//                         const page1Print = this.state.templateImages.find(
//                           (s) => s.pageNumber === 1 && s.slotNumber === 2
//                         );
//                         return page1App?.file && page1Print?.file ? (
//                           <Button
//                             variant="contained"
//                             color="primary"
//                             size="small"
//                             onClick={this.handleReplicatePage1ToAll}
//                             style={{ backgroundColor: "#1976d2", color: "#fff", whiteSpace: "nowrap" }}
//                           >
//                             📋 Replicate Page 1 to All Pages
//                           </Button>
//                         ) : null;
//                       })()}
//                     </Box>
//                     {Array.from(
//                       { length: this.state.templateImages.length / 2 },
//                       (_, pageIdx) => pageIdx + 1
//                     ).map((pageNumber) => {
//                       const pageSlots = this.state.templateImages.filter(
//                         (s) => s.pageNumber === pageNumber
//                       );
//                       const appAssetSlot = pageSlots.find((s) => s.slotNumber === 1);
//                       const printAssetSlot = pageSlots.find((s) => s.slotNumber === 2);

//                       // Shared layoutId per page — use appAsset slot to store it
//                       const pageLayoutId = appAssetSlot?.layoutId || "";
//                       const pageLayoutError = appAssetSlot?.layoutIdError || "";

//                       return (
//                         <Box key={pageNumber} mb={2}>
//                           <Typography
//                             variant="subtitle2"
//                             style={{ fontWeight: 600, color: "#555", marginBottom: 8 }}
//                           >
//                             Page {pageNumber}
//                           </Typography>

//                           <Grid container spacing={2} alignItems="stretch">

//                             {/* ── Column 1: App Asset ── */}
//                             <Grid item xs={12} sm={5} style={{ display: "flex" }}>
//                               {appAssetSlot && (
//                                 <Card elevation={2} style={{ borderRadius: 8, width: "100%", display: "flex", flexDirection: "column" }}>
//                                   <input
//                                     type="file"
//                                     accept="image/*"
//                                     id={`template-upload-${appAssetSlot.slotKey}`}
//                                     style={{ display: "none" }}
//                                     onChange={(e) => {
//                                       const file = e.target.files[0];
//                                       if (file) this.handleTemplateImageUpload(appAssetSlot.slotKey, file);
//                                       e.target.value = "";
//                                     }}
//                                   />
//                                   <label htmlFor={`template-upload-${appAssetSlot.slotKey}`} style={{ cursor: "pointer", display: "block" }}>
//                                     <Tooltip title={appAssetSlot.preview ? "Click to replace image" : "Click to upload image"}>
//                                       <div
//                                         style={{
//                                           width: "100%",
//                                           height: 160,
//                                           backgroundColor: "#f5f5f5",
//                                           border: appAssetSlot.preview ? "1px solid #e0e0e0" : "2px dashed #ccc",
//                                           borderRadius: "8px 8px 0 0",
//                                           overflow: "hidden",
//                                           display: "flex",
//                                           alignItems: "center",
//                                           justifyContent: "center",
//                                           transition: "opacity 0.2s",
//                                         }}
//                                         onMouseEnter={(e) => e.currentTarget.style.opacity = "0.85"}
//                                         onMouseLeave={(e) => e.currentTarget.style.opacity = "1"}
//                                       >
//                                         {appAssetSlot.preview ? (
//                                           <img
//                                             src={appAssetSlot.preview}
//                                             alt={appAssetSlot.slotKey}
//                                             style={{ width: "100%", height: "100%", objectFit: "contain", backgroundColor: "#f5f5f5" }}
//                                           />
//                                         ) : (
//                                           <div style={{ textAlign: "center", color: "#bbb" }}>
//                                             <img src={ckLogo} alt="preview" style={{ width: "20%", height: "20%", objectFit: "contain" }} />
//                                             <Typography variant="caption" style={{ color: "#bbb", display: "block", marginTop: 4 }}>
//                                               Click to upload
//                                             </Typography>
//                                           </div>
//                                         )}
//                                       </div>
//                                     </Tooltip>
//                                   </label>
//                                   <CardContent style={{ padding: "8px 10px" }}>
//                                     <Typography variant="caption" style={{ fontWeight: 600, color: "#1976d2", display: "block", marginBottom: 2 }}>
//                                       App Asset
//                                     </Typography>
//                                     {appAssetSlot.file && (
//                                       <Typography
//                                         variant="caption"
//                                         color="textSecondary"
//                                         style={{ display: "block", whiteSpace: "nowrap", overflow: "hidden", textOverflow: "ellipsis", marginBottom: 2 }}
//                                         title={appAssetSlot.generatedFileName || appAssetSlot.file.name}
//                                       >
//                                         📄 {appAssetSlot.generatedFileName || appAssetSlot.file.name}
//                                       </Typography>
//                                     )}
//                                     {appAssetSlot.dimensions && (
//                                       <Typography variant="caption" style={{ color: "#888", display: "block", marginBottom: 4 }}>
//                                         📐 {appAssetSlot.dimensions.width} × {appAssetSlot.dimensions.height} px
//                                       </Typography>
//                                     )}
//                                     {appAssetSlot.preview && (
//                                       <Box display="flex" justifyContent="flex-end">
//                                         <Tooltip title="Remove image">
//                                           <IconButton size="small" onClick={() => this.handleTemplateImageRemove(appAssetSlot.slotKey)} style={{ color: "#f44336", padding: 4 }}>
//                                             <CloseIcon fontSize="small" />
//                                           </IconButton>
//                                         </Tooltip>
//                                       </Box>
//                                     )}
//                                   </CardContent>
//                                 </Card>
//                               )}
//                             </Grid>

//                             {/* ── Column 2: Print Asset ── */}
//                             <Grid item xs={12} sm={5} style={{ display: "flex" }}>
//                               {printAssetSlot && (
//                                 <Card elevation={2} style={{ borderRadius: 8, width: "100%", display: "flex", flexDirection: "column" }}>
//                                   <input
//                                     type="file"
//                                     accept="image/*"
//                                     id={`template-upload-${printAssetSlot.slotKey}`}
//                                     style={{ display: "none" }}
//                                     onChange={(e) => {
//                                       const file = e.target.files[0];
//                                       if (file) this.handleTemplateImageUpload(printAssetSlot.slotKey, file);
//                                       e.target.value = "";
//                                     }}
//                                   />
//                                   <label htmlFor={`template-upload-${printAssetSlot.slotKey}`} style={{ cursor: "pointer", display: "block" }}>
//                                     <Tooltip title={printAssetSlot.preview ? "Click to replace image" : "Click to upload image"}>
//                                       <div
//                                         style={{
//                                           width: "100%",
//                                           height: 160,
//                                           backgroundColor: "#f5f5f5",
//                                           border: printAssetSlot.preview ? "1px solid #e0e0e0" : "2px dashed #ccc",
//                                           borderRadius: "8px 8px 0 0",
//                                           overflow: "hidden",
//                                           display: "flex",
//                                           alignItems: "center",
//                                           justifyContent: "center",
//                                           transition: "opacity 0.2s",
//                                         }}
//                                         onMouseEnter={(e) => e.currentTarget.style.opacity = "0.85"}
//                                         onMouseLeave={(e) => e.currentTarget.style.opacity = "1"}
//                                       >
//                                         {printAssetSlot.preview ? (
//                                           <img
//                                             src={printAssetSlot.preview}
//                                             alt={printAssetSlot.slotKey}
//                                             style={{ width: "100%", height: "100%", objectFit: "contain", backgroundColor: "#f5f5f5" }}
//                                           />
//                                         ) : (
//                                           <div style={{ textAlign: "center", color: "#bbb" }}>
//                                             <img src={ckLogo} alt="preview" style={{ width: "20%", height: "20%", objectFit: "contain" }} />
//                                             <Typography variant="caption" style={{ color: "#bbb", display: "block", marginTop: 4 }}>
//                                               Click to upload
//                                             </Typography>
//                                           </div>
//                                         )}
//                                       </div>
//                                     </Tooltip>
//                                   </label>
//                                   <CardContent style={{ padding: "8px 10px" }}>
//                                     <Typography variant="caption" style={{ fontWeight: 600, color: "#e65100", display: "block", marginBottom: 2 }}>
//                                       Print Asset
//                                     </Typography>
//                                     {printAssetSlot.file && (
//                                       <Typography
//                                         variant="caption"
//                                         color="textSecondary"
//                                         style={{ display: "block", whiteSpace: "nowrap", overflow: "hidden", textOverflow: "ellipsis", marginBottom: 2 }}
//                                         title={printAssetSlot.generatedFileName || printAssetSlot.file.name}
//                                       >
//                                         📄 {printAssetSlot.generatedFileName || printAssetSlot.file.name}
//                                       </Typography>
//                                     )}
//                                     {printAssetSlot.dimensions && (
//                                       <Typography variant="caption" style={{ color: "#888", display: "block", marginBottom: 4 }}>
//                                         📐 {printAssetSlot.dimensions.width} × {printAssetSlot.dimensions.height} px
//                                       </Typography>
//                                     )}
//                                     {printAssetSlot.preview && (
//                                       <Box display="flex" justifyContent="flex-end">
//                                         <Tooltip title="Remove image">
//                                           <IconButton size="small" onClick={() => this.handleTemplateImageRemove(printAssetSlot.slotKey)} style={{ color: "#f44336", padding: 4 }}>
//                                             <CloseIcon fontSize="small" />
//                                           </IconButton>
//                                         </Tooltip>
//                                       </Box>
//                                     )}
//                                   </CardContent>
//                                 </Card>
//                               )}
//                             </Grid>

//                             {/* ── Column 3: Layout Picker ── */}
//                             <Grid item xs={12} sm={2} style={{ display: "flex" }}>
//                               <Card elevation={2} style={{
//                                 borderRadius: 8,
//                                 width: "100%",
//                                 display: "flex",
//                                 flexDirection: "column",
//                                 justifyContent: "flex-start",
//                                 padding: 12,
//                               }}>
//                                 <Typography variant="caption" style={{ fontWeight: 600, color: "#555", display: "block", marginBottom: 8 }}>
//                                   Layout
//                                 </Typography>

//                                 {/* ── Picture count dropdown ── */}
//                                 {(() => {
//                                   const pictureOptions = [...new Set(
//                                     this.state.layoutsList.map((l) => l.totalPictures).filter((v) => v != null)
//                                   )].sort((a, b) => a - b);

//                                   const selectedLayout = this.state.layoutsList.find(
//                                     (l) => String(l.layoutId) === String(pageLayoutId)
//                                   );

//                                   return (
//                                     <>
//                                       <TextField
//                                         select
//                                         size="small"
//                                         fullWidth
//                                         variant="outlined"
//                                         label="Pictures"
//                                         value={selectedLayout?.totalPictures ?? ""}
//                                         error={!!pageLayoutError}
//                                         onChange={(e) => {
//                                           // just opens the picker filtered to this count
//                                           this.setState({ layoutPickerOpenPage: pageNumber, _pickerFilter: e.target.value });
//                                         }}
//                                         style={{ marginBottom: 8 }}
//                                       >
//                                         {pictureOptions.map((n) => (
//                                           <MenuItem key={n} value={n}>
//                                             {n} Picture{n !== 1 ? "s" : ""}
//                                           </MenuItem>
//                                         ))}
//                                       </TextField>

//                                       {/* Browse all layouts button */}
//                                       <Button
//                                         variant="outlined"
//                                         size="small"
//                                         fullWidth
//                                         onClick={() => this.setState({ layoutPickerOpenPage: pageNumber, _pickerFilter: null })}
//                                         style={{
//                                           borderColor: pageLayoutError ? "#f44336" : "#1976d2",
//                                           color: pageLayoutError ? "#f44336" : "#1976d2",
//                                           textTransform: "none",
//                                           fontSize: 11,
//                                           marginBottom: 4,
//                                         }}
//                                       >
//                                         {pageLayoutId ? "Change Layout" : "Browse Layouts…"}
//                                       </Button>

//                                       {pageLayoutError && (
//                                         <Typography variant="caption" style={{ color: "#f44336", display: "block", marginBottom: 4 }}>
//                                           {pageLayoutError}
//                                         </Typography>
//                                       )}

//                                       <Typography variant="caption" style={{ color: "#888", display: "block", marginBottom: 4 }}>
//                                         Shared for App & Print Asset
//                                       </Typography>

//                                       {/* ── Layout slot preview (selected layout) ── */}
//                                       {(() => {
//                                         const overlay = this.getCollageOverlay(pageLayoutId, pageNumber);
//                                         return (
//                                           <LayoutPreview
//                                             exportWidth={overlay ? overlay.exportWidth : null}
//                                             exportHeight={overlay ? overlay.exportHeight : null}
//                                             collageInfoList={overlay ? overlay.collageInfoList : null}
//                                           />
//                                         );
//                                       })()}

//                                       {/* ── Picker dialog ── */}
//                                       <LayoutPickerDialog
//                                         open={this.state.layoutPickerOpenPage === pageNumber}
//                                         onClose={() => this.setState({ layoutPickerOpenPage: null })}
//                                         layoutsList={this.state.layoutsList}
//                                         selectedLayoutId={pageLayoutId}
//                                         pageNumber={pageNumber}
//                                         getCollageOverlay={this.getCollageOverlay}
//                                         initialFilter={this.state._pickerFilter ?? null}
//                                         onSelect={(newLayoutId) => {
//                                           this.setState((prev) => ({
//                                             layoutPickerOpenPage: null,
//                                             templateImages: prev.templateImages.map((slot) => {
//                                               if (slot.pageNumber !== pageNumber) return slot;
//                                               const updatedSlot = { ...slot, layoutId: newLayoutId, layoutIdError: "" };
//                                               if (updatedSlot.file) {
//                                                 const generatedName = this.generateAssetFileName(updatedSlot);
//                                                 const renamedFile = new File([updatedSlot.file], generatedName, { type: updatedSlot.file.type });
//                                                 return { ...updatedSlot, file: renamedFile, generatedFileName: generatedName };
//                                               }
//                                               return updatedSlot;
//                                             }),
//                                           }));
//                                         }}
//                                       />
//                                     </>
//                                   );
//                                 })()}
//                               </Card>
//                             </Grid>

//                           </Grid>
//                           <Divider style={{ marginTop: 12 }} />
//                         </Box>
//                       );
//                     })}
//                   </Grid>
//                 )}

//                 {/* ── Action Buttons ── */}
//                 <Grid align="end" style={{ marginTop: 16 }} item xs={12}>
//                   <Button
//                     onClick={(e) => this.submitForm(e)}
//                     className={classes.button}
//                     color="primary"
//                     variant="contained"
//                     disabled={this.state.isLoading}
//                   >
//                     {this.state.isLoading ? (
//                       <CircularProgress size={23} style={{ color: "white" }} />
//                     ) : (
//                       this.state.recordId == 0 ? "Save" : "Update"
//                     )}
//                   </Button>


//                 </Grid>

//               </Grid>
//             </CardContent>
//           </Card>
//         </Grid>
//       </Fragment >
//     );
//   }
// }

// F15AddNewThemeForm.propTypes = {
//   classes: PropTypes.object.isRequired,
//   match: PropTypes.object,
// };

// F15AddNewThemeForm.defaultProps = {
//   match: { params: { recordId: 0 } },
// };
// Object.assign(F15AddNewThemeForm.prototype, LayoutMethods);

// export default withStyles(useStyles)(F15AddNewThemeForm);

/* eslint-disable eqeqeq */
import React, { Fragment } from "react";
import PropTypes from "prop-types";
import { withStyles } from "@material-ui/styles";
import {
  Grid,
  MenuItem,
  TextField,
  Typography,
  Button,
  Divider,
  CircularProgress,
  Card,
  CardContent,
  Toolbar, Tooltip, Box,
  Dialog, DialogTitle, DialogContent, Chip,
} from "@material-ui/core";
import Select from "react-select";
import { HttpRequest } from "../../../utils/httpRequests";
import NavBar from "../../../components/NavBar/NavBar";
import CustomizedSnackbar from "../../../components/CustomizedSnackbar/CustomizedSnackbar";
import LoginMenu from "../../../components/LoginMenu/LoginMenu";
import BottomBar from "../../../components/BottomBar/BottomBar";
import { Close as CloseIcon } from "@material-ui/icons";
import PublishIcon from "@material-ui/icons/Publish";
import { IconButton } from "@material-ui/core";
import ckLogo from "../../../assets/images/ck_logo_new.png";
import LayoutMethods from '../../../components/Layouts/layoutMethods';



// ── Layout preview: empty container with correct aspect ratio + red slot squares + dimension labels ──
const LayoutPreview = ({ exportWidth, exportHeight, collageInfoList }) => {
  if (!exportWidth || !exportHeight) return null;

  const ratio = exportWidth / exportHeight;
  const paddingTop = (1 / ratio) * 100;

  return (
    <div style={{ marginTop: 10 }}>
      {/* canvas dimensions label */}
      <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center", marginBottom: 3 }}>
        <span style={{ fontSize: 9, color: "#7986cb", fontWeight: 600, letterSpacing: 0.3 }}>
          LAYOUT PREVIEW
        </span>
        <span style={{ fontSize: 9, color: "#9fa8da", fontWeight: 500 }}>
          {exportWidth} × {exportHeight} px
        </span>
      </div>

      {/* aspect-ratio container */}
      <div style={{ position: "relative", width: "100%", paddingTop: `${paddingTop}%`, backgroundColor: "#e8eaf6", border: "1.5px solid #9fa8da", borderRadius: 4, overflow: "hidden" }}>
        {/* subtle grid */}
        <div style={{
          position: "absolute", inset: 0,
          backgroundImage: "linear-gradient(rgba(0,0,0,0.05) 1px, transparent 1px), linear-gradient(90deg, rgba(0,0,0,0.05) 1px, transparent 1px)",
          backgroundSize: "10% 10%",
        }} />

        {/* red slot rectangles */}
        {collageInfoList && collageInfoList.map((info, i) => {
          const slotWpx = Math.round(info.getWidth() * exportWidth);
          const slotHpx = Math.round(info.getHeight() * exportHeight);
          const slotLpx = Math.round(info.getLeft() * exportWidth);
          const slotTpx = Math.round(info.getTop() * exportHeight);
          return (
            <div
              key={i}
              style={{
                position: "absolute",
                left: `${info.getLeft() * 100}%`,
                top: `${info.getTop() * 100}%`,
                width: `${info.getWidth() * 100}%`,
                height: `${info.getHeight() * 100}%`,
                backgroundColor: "rgba(211, 47, 47, 0.15)",
                border: "2px solid rgba(211, 47, 47, 0.85)",
                borderRadius: 2,
                boxSizing: "border-box",
                display: "flex",
                flexDirection: "column",
                alignItems: "center",
                justifyContent: "center",
                gap: 1,
                padding: 2,
              }}
            >
              <span style={{ fontSize: 8, color: "rgba(183,28,28,0.95)", fontWeight: 700, letterSpacing: 0.4, userSelect: "none", lineHeight: 1.2 }}>
                SLOT {i + 1}
              </span>
              <span style={{ fontSize: 7, color: "rgba(183,28,28,0.8)", fontWeight: 500, userSelect: "none", lineHeight: 1.2 }}>
                {slotWpx} × {slotHpx}
              </span>
              <span style={{ fontSize: 7, color: "rgba(120,20,20,0.6)", fontWeight: 400, userSelect: "none", lineHeight: 1.2 }}>
                @ {slotLpx}, {slotTpx}
              </span>
            </div>
          );
        })}

        {/* empty state */}
        {(!collageInfoList || collageInfoList.length === 0) && (
          <div style={{ position: "absolute", inset: 0, display: "flex", alignItems: "center", justifyContent: "center" }}>
            <span style={{ fontSize: 10, color: "#9fa8da", fontWeight: 500 }}>Select layout to preview</span>
          </div>
        )}
      </div>

      {/* per-slot dimension rows below container */}
      {collageInfoList && collageInfoList.length > 0 && (
        <div style={{ marginTop: 5 }}>
          {collageInfoList.map((info, i) => (
            <div key={i} style={{ display: "flex", justifyContent: "space-between", marginBottom: 2 }}>
              <span style={{ fontSize: 8, color: "#d32f2f", fontWeight: 600 }}>Slot {i + 1}</span>
              <span style={{ fontSize: 8, color: "#555" }}>
                {Math.round(info.getWidth() * exportWidth)} × {Math.round(info.getHeight() * exportHeight)} px
              </span>
              <span style={{ fontSize: 8, color: "#888" }}>
                x:{Math.round(info.getLeft() * exportWidth)}  y:{Math.round(info.getTop() * exportHeight)}
              </span>
            </div>
          ))}
        </div>
      )}
    </div>
  );
};

// ── Layout Picker Dialog ──
class LayoutPickerDialog extends React.Component {
  constructor(props) {
    super(props);
    this.state = { selectedPictures: null };
  }

  componentDidUpdate(prev) {
    if (!prev.open && this.props.open) {
      // when dialog opens, pre-set filter from parent (picture count dropdown selection)
      this.setState({ selectedPictures: this.props.initialFilter ?? null });
    }
  }

  render() {
    const { open, onClose, layoutsList, onSelect, selectedLayoutId, getCollageOverlay, pageNumber } = this.props;
    const { selectedPictures } = this.state;

    // distinct totalPictures values
    const pictureOptions = [...new Set(
      layoutsList.map((l) => l.totalPictures).filter((v) => v != null)
    )].sort((a, b) => a - b);

    const filtered = layoutsList.filter((l) =>
      selectedPictures == null ? true : l.totalPictures === selectedPictures
    );

    return (
      <Dialog open={open} onClose={onClose} maxWidth="md" fullWidth
        PaperProps={{ style: { borderRadius: 12, maxHeight: "90vh" } }}>
        <DialogTitle style={{ paddingBottom: 8 }}>
          <Box display="flex" alignItems="center" justifyContent="space-between">
            <Typography variant="h6" style={{ fontWeight: 700, color: "#333" }}>
              Select Layout
            </Typography>
            <IconButton size="small" onClick={onClose}>
              <CloseIcon />
            </IconButton>
          </Box>

          {/* picture count filter chips */}
          <Box display="flex" flexWrap="wrap" style={{ gap: 6, marginTop: 10 }}>
            <Chip
              label="All"
              size="small"
              onClick={() => this.setState({ selectedPictures: null })}
              style={{
                backgroundColor: selectedPictures == null ? "#1976d2" : "#e0e0e0",
                color: selectedPictures == null ? "#fff" : "#333",
                fontWeight: 600, cursor: "pointer",
              }}
            />
            {pictureOptions.map((n) => (
              <Chip
                key={n}
                label={`${n} Picture${n !== 1 ? "s" : ""}`}
                size="small"
                onClick={() => this.setState({ selectedPictures: n })}
                style={{
                  backgroundColor: selectedPictures === n ? "#1976d2" : "#e0e0e0",
                  color: selectedPictures === n ? "#fff" : "#333",
                  fontWeight: 600, cursor: "pointer",
                }}
              />
            ))}
          </Box>
        </DialogTitle>

        <DialogContent dividers style={{ padding: 16 }}>
          {filtered.length === 0 && (
            <Typography variant="body2" style={{ color: "#888", textAlign: "center", marginTop: 32 }}>
              No layouts available.
            </Typography>
          )}
          <Grid container spacing={2}>
            {filtered.map((layout) => {
              const overlay = getCollageOverlay(layout.layoutId, pageNumber);
              const isSelected = String(selectedLayoutId) === String(layout.layoutId);
              return (
                <Grid item xs={12} sm={6} md={4} key={layout.layoutId}>
                  <Card
                    elevation={isSelected ? 6 : 2}
                    onClick={() => { onSelect(layout.layoutId); onClose(); }}
                    style={{
                      borderRadius: 8,
                      border: isSelected ? "2px solid #1976d2" : "2px solid transparent",
                      cursor: "pointer",
                      transition: "box-shadow 0.15s, border 0.15s",
                      overflow: "hidden",
                    }}
                  >
                    {/* preview area */}
                    <Box style={{ padding: "10px 10px 0 10px", backgroundColor: isSelected ? "#e3f2fd" : "#fafafa" }}>
                      <LayoutPreview
                        exportWidth={overlay ? overlay.exportWidth : null}
                        exportHeight={overlay ? overlay.exportHeight : null}
                        collageInfoList={overlay ? overlay.collageInfoList : null}
                      />
                    </Box>

                    {/* info footer */}
                    <CardContent style={{ padding: "8px 10px 10px 10px", backgroundColor: isSelected ? "#e3f2fd" : "#fff" }}>
                      <Box display="flex" alignItems="center" justifyContent="space-between">
                        <Typography variant="caption" style={{ fontWeight: 700, color: isSelected ? "#1976d2" : "#333", fontSize: 12 }}>
                          {layout.layoutNo}{layout.label ? ` — ${layout.label}` : ""}
                        </Typography>
                        {isSelected && (
                          <Chip label="Selected" size="small" style={{ backgroundColor: "#1976d2", color: "#fff", fontSize: 9, height: 18 }} />
                        )}
                      </Box>
                      {layout.totalPictures != null && (
                        <Typography variant="caption" style={{ color: "#888", display: "block", marginTop: 2 }}>
                          {layout.totalPictures} picture{layout.totalPictures !== 1 ? "s" : ""}
                        </Typography>
                      )}
                    </CardContent>
                  </Card>
                </Grid>
              );
            })}
          </Grid>
        </DialogContent>
      </Dialog>
    );
  }
}

const getExpectedAspectRatio = (sizeId, pageNumber, slotNumber, categoryId) => {
  // slotNumber 1 = App Asset (ic), slotNumber 2 = Print Asset (fl)
  // ic and fl share the same aspect ratio — ic is just a scaled-down version.
  const id = parseInt(categoryId);
  const totalPages = { 2: 24, 6: 12, 9: 1 }[id] || 0;
  const isFrontCover = pageNumber === 1;
  const isBackCover = pageNumber === totalPages && totalPages > 1;

  if (id === 2) {
    if (sizeId === 2) {
      if (isFrontCover) return 3796 / 3000;
      if (isBackCover) return 4010 / 3000;
      return 3508 / 2400;
    }
    if (sizeId === 4) {
      if (isFrontCover) return 2737 / 3000;
      if (isBackCover) return 2961 / 3000;
      return 2400 / 2400;
    }
  } else if (id === 9) {
    if (sizeId === 22) return 2550 / 1050;
    if (sizeId === 23) return 2550 / 1125;
    return 2550 / 1050;
  } else if (id === 6) {
    if (sizeId === 12 || sizeId === 14) return 3600 / 5400;
    if (sizeId === 15) return 3600 / 3600;
    return 3600 / 5400;
  }


  // if (id === 2) {
  //   if (sizeLabel === "Landscape") {
  //     if (isFrontCover) return 3796 / 3000; // 1.2653
  //     if (isBackCover) return 4010 / 3000; // 1.3367
  //     return 3508 / 2400; // 1.4617 — Inner Pages
  //   }
  //   if (sizeLabel === "Square") {
  //     if (isFrontCover) return 2737 / 3000; // 0.9123
  //     if (isBackCover) return 2961 / 3000; // 0.9870
  //     return 2400 / 2400; // 1.0000 — Inner Pages
  //   }
  // } else if (id === 6) {       // ← ADDED HERE
  //   if (sizeLabel === "Classic 12x18''" || sizeLabel === "Portrait 12x18''") return 3600 / 5400;
  //   if (sizeLabel === "Square 12x12''") return 3600 / 3600;
  //   return 3600 / 5400;
  // }

  // else if (id === 9) {
  //   if (sizeLabel === "Regular Mug") return 2550 / 1050; // 2.4286
  //   if (sizeLabel === "Big Mug") return 2550 / 1125; // 2.2667
  //   return 2550 / 1050; // fallback
  // }

  return null; // no rule — skip validation
};

const ASPECT_RATIO_TOLERANCE = 0.01; // ±0.01 ratio tolerance (~0.8%)

const useStyles = () => ({
  root: {
    padding: 10,
    margin: "70px 20px",
  },
  topMargin: {
    marginTop: 20,
  },
  button: {
    textTransform: "capitalize",
    marginLeft: 10,
    padding: 10,
    width: 110,
  },
  sectionLabel: {
    fontWeight: 600,
    color: "#555",
    marginBottom: 8,
    marginTop: 16,
  },
});

class F15AddNewThemeForm extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      isLoading: false,
      recordId: 0,

      // ── Dropdown Data ──
      categoriesList: [],
      categoriesLoading: false,

      themeCategoriesList: [],
      themeCategoriesLoading: false,

      sizesList: [],
      sizesLoading: false,

      totalPagesList: [],

      numberOfPages: "20",       // ← Number of Pages (only for Themed Photobooks categoryId==2)
      numberOfPagesError: "",

      productTypesList: [],
      productTypesLoading: false,

      bundlesList: [],
      bundlesLoading: false,

      // ── Selected Values ──
      categoryId: "",
      categoryIdError: "",

      themeCategoryId: "",
      themeCategoryIdError: "",

      sizeId: "",
      sizeIdError: "",

      totalPages: "",
      totalPagesError: "",

      selectedProductTypes: [],
      selectedProductTypesError: "",

      layoutsList: [],
      layoutsLoading: false,

      selectedLayouts: [],
      selectedLayoutsError: "",

      // bundleId: "",
      // bundleIdError: "",
      selectedBundles: [],
      selectedBundlesError: "",


      // ── Text Fields ──
      description: "",
      descriptionError: "",

      themeLabel: "",
      themeLabelError: "",

      // ── UI State ──
      isOpenSnackbar: false,
      snackbarMessage: "",
      snackbarSeverity: "",
      isLoginMenu: false,
      isReload: true,
      layoutPickerOpenPage: null, // pageNumber of the dialog currently open, or null
      templateImages: [], // array of { pageNumber, slotNumber, file, preview }
    };
  }

  componentDidMount() {
    this.fetchCategories();
    this.fetchThemeCategories();

    // 


    const id = this.props.match?.params?.recordId;
    if (id && id != 0) {
      this.setState({ recordId: id });
      this.getData(id);
    }
  }

  UNSAFE_componentWillReceiveProps(nextProps) {
    if (this.props.match?.params?.recordId != nextProps.match?.params?.recordId) {
      if (nextProps.match?.params?.recordId != 0) {
        this.getData(nextProps.match?.params?.recordId);
      } else {
        window.location.reload();
      }
    }
  }

  buildTemplateSlots = (categoryId, numberOfPages) => {
    const pages2 = numberOfPages || this.state.numberOfPages || "20";
    const photoBookPages = parseInt(pages2) === 10 ? 14 : 24;
    const pagesMap = { 2: photoBookPages, 6: 12, 9: 1 };
    const totalPages = pagesMap[parseInt(categoryId)] || 0;
    const imagesPerPage = 2;
    const slotLabels = { 1: "App Asset", 2: "Print Asset" };

    const slots = [];
    for (let page = 1; page <= totalPages; page++) {
      for (let slot = 1; slot <= imagesPerPage; slot++) {
        slots.push({
          pageNumber: page,
          slotNumber: slot,
          slotLabel: slotLabels[slot],
          slotKey: `page${page}_slot${slot}`,
          file: null,
          preview: null,
          dimensions: null,
          layoutId: "",      // ← new
          layoutIdError: "", // ← new
        });
      }
    }
    this.setState({ templateImages: slots });
  };
  // buildTemplateSlots = (categoryId) => {
  //   const pagesMap = { 2: 24, 6: 12, 9: 1 };
  //   const totalPages = pagesMap[categoryId] || 0;
  //   const imagesPerPage = 2;
  //   const slotLabels = { 1: "App Asset", 2: "Print Asset" };

  //   const slots = [];
  //   for (let page = 1; page <= totalPages; page++) {
  //     for (let slot = 1; slot <= imagesPerPage; slot++) {
  //       slots.push({
  //         pageNumber: page,
  //         slotNumber: slot,
  //         slotLabel: slotLabels[slot],
  //         slotKey: `page${page}_slot${slot}`,
  //         file: null,
  //         preview: null,
  //       });
  //     }
  //   }
  //   this.setState({ templateImages: slots });
  // };

  // buildTemplateSlots = (categoryId) => {
  //   const pagesMap = { 2: 24, 6: 12, 9: 1 };
  //   const totalPages = pagesMap[categoryId] || 0;
  //   const imagesPerPage = 2;

  //   const slots = [];
  //   for (let page = 1; page <= totalPages; page++) {
  //     for (let slot = 1; slot <= imagesPerPage; slot++) {
  //       slots.push({
  //         pageNumber: page,
  //         slotNumber: slot,
  //         slotKey: `page${page}_slot${slot}`,
  //         file: null,
  //         preview: null,
  //       });
  //     }
  //   }
  //   this.setState({ templateImages: slots });
  // };

  handleTemplateLayoutChange = (slotKey, layoutId) => {
    this.setState((prev) => ({
      templateImages: prev.templateImages.map((slot) =>
        slot.slotKey === slotKey
          ? { ...slot, layoutId, layoutIdError: "" }
          : slot
      ),
    }));
  };

  fetchCategories = async () => {
    this.setState({ categoriesLoading: true });
    const res = await HttpRequest(
      "GET",
      `${process.env.REACT_APP_API_DOMAIN}/${process.env.REACT_APP_SUB_API_NAME}/common/C15CommonProductsCategoriesView`,
      null,
      "authorizeJson"
    );
    if (res.isSuccess) {
      const ALLOWED_IDS = [2, 6, 9];
      const ALIAS_MAP = { 2: "pb", 6: "cl", 9: "mg" };
      const filtered = (res.data || [])
        .filter((item) => ALLOWED_IDS.includes(item.id))
        .map((item) => ({ ...item, alias: ALIAS_MAP[item.id] || "" }));
      this.setState({ categoriesList: filtered });
    } else {
      if (res.statusCode === 401) this.setState({ isLoginMenu: true });
    }
    this.setState({ categoriesLoading: false });
  };

  // fetchPages = async (categoryId) => {
  //   this.setState({ categoriesLoading: true });
  //   const res = await HttpRequest(
  //     "GET",
  //     `${process.env.REACT_APP_API_DOMAIN}/${process.env.REACT_APP_SUB_API_NAME}/common/C15CommonProductsPagesView?categoryId=${categoryId}`,
  //     null,
  //     "authorizeJson"
  //   );
  //   if (res.isSuccess) {

  //     this.setState({ totalPagesList: res.data || [] });
  //   } else {
  //     if (res.statusCode === 401) this.setState({ isLoginMenu: true });
  //   }
  //   this.setState({ categoriesLoading: false });
  // };

  buildTotalPagesList = (categoryId, numberOfPages) => {
    let pages = [];
    const pages2 = numberOfPages || this.state.numberOfPages || "20";

    if (categoryId == 2) {
      // Themed Photobooks — driven by numberOfPages dropdown (20 or 10)
      const totalPagesVal = parseInt(pages2) === 10 ? 10 : 20;
      // actual page count for the book (first+last + inner pages)
      const bookPages = totalPagesVal === 10 ? 12 : 24;
      pages = [{ value: bookPages, label: `${bookPages} Pages` }];
    } else if (categoryId == 6) {
      pages = [{ value: 12, label: "12 Pages" }];
    } else if (categoryId == 9) {
      pages = [{ value: 1, label: "1 Page" }];
    }

    this.setState({ totalPagesList: pages, totalPages: pages.length === 1 ? pages[0].value : "" });
  };




  fetchThemeCategories = async () => {
    this.setState({ themeCategoriesLoading: true });
    const res = await HttpRequest(
      "GET",
      `${process.env.REACT_APP_API_DOMAIN}/${process.env.REACT_APP_SUB_API_NAME}/common/C15CommonProductsThemeCategoriesView`,
      null,
      "authorizeJson"
    );
    if (res.isSuccess) {
      this.setState({ themeCategoriesList: res.data || [] });
    } else {
      if (res.statusCode === 401) this.setState({ isLoginMenu: true });
    }
    this.setState({ themeCategoriesLoading: false });
  };

  fetchSizes = async (categoryId) => {
    this.setState({ sizesLoading: true });
    const res = await HttpRequest(
      "GET",
      `${process.env.REACT_APP_API_DOMAIN}/${process.env.REACT_APP_SUB_API_NAME}/common/C15CommonProductsSizesView?categoryId=${categoryId}`,
      null,
      "authorizeJson"
    );
    if (res.isSuccess) {
      this.setState({ sizesList: res.data || [] });
    } else {
      if (res.statusCode === 401) this.setState({ isLoginMenu: true });
    }
    this.setState({ sizesLoading: false });
  };



  fetchLayouts = async (categoryId) => {
    this.setState({ layoutsLoading: true });
    const res = await HttpRequest(
      "GET",
      `${process.env.REACT_APP_API_DOMAIN}/${process.env.REACT_APP_SUB_API_NAME}/common/C15CommonProductsThemeAssetsLayoutsController?categoryId=${categoryId}`,
      null,
      "authorizeJson"
    );
    if (res.isSuccess) {
      this.setState({ layoutsList: res.data || [] });
    } else {
      if (res.statusCode === 401) this.setState({ isLoginMenu: true });
    }
    this.setState({ layoutsLoading: false });
  };



  fetchProductTypes = async (categoryId) => {
    this.setState({ productTypesLoading: true });
    const res = await HttpRequest(
      "GET",
      `${process.env.REACT_APP_API_DOMAIN}/${process.env.REACT_APP_SUB_API_NAME}/common/C15CommonProductsTypesView?categoryId=${categoryId}`,
      null,
      "authorizeJson"
    );
    if (res.isSuccess) {
      const list = (res.data || []).map((item) => ({
        value: item.id,
        label: item.label,
        id: item.id,
        isFixed: false,
        isDisabled: false,
      }));
      this.setState({ productTypesList: list });
    } else {
      if (res.statusCode === 401) this.setState({ isLoginMenu: true });
    }
    this.setState({ productTypesLoading: false });
  };

  // fetchBundles = async (categoryId) => {
  //   this.setState({ bundlesLoading: true });
  //   if (categoryId == 9) {
  //     this.setState({ bundlesList: [{ value: 1, label: "Bundle of 1" }, { value: 2, label: "Bundle of 2" }] });
  //   }
  //   this.setState({ bundlesLoading: false });
  // };

  fetchBundles = async (categoryId) => {
    this.setState({ bundlesLoading: true });
    if (categoryId == 9) {
      this.setState({
        bundlesList: [
          { value: 1, label: "Bundle of 1", id: 1 },
          { value: 2, label: "Bundle of 2", id: 2 },
        ],
      });
    } else {
      this.setState({ bundlesList: [] });
    }
    this.setState({ bundlesLoading: false });
  };

  getData = async (id) => {
    const res = await HttpRequest(
      "GET",
      `${process.env.REACT_APP_API_DOMAIN}/${process.env.REACT_APP_SUB_API_NAME}/common/C15ALLThemesFormView?recordId=${id}`,
      null,
      "authorizeJson"
    );
    if (res.isSuccess && res.data && res.data.length > 0) {
      const d = res.data[0];
      this.setState({
        categoryId: d.categoryId || "",
        themeCategoryId: d.themeCategoryId || "",
        sizeId: d.sizeId || "",
        totalPages: d.totalPages || "",
        bundleId: d.bundleId || "",
        description: d.description || "",
        themeLabel: d.themeLabel || "",
        selectedProductTypes: d.productTypes
          ? d.productTypes.map((pt) => ({ value: pt.id, label: pt.label, id: pt.id }))
          : [],
      });
    } else {
      if (res.statusCode === 401) this.setState({ isLoginMenu: true });
      else this.handleSnackbar(true, res.message || "Failed to load data", "error");
    }
  };

  // handleChange = (e) => {
  //   const { name, value } = e.target;
  //   this.setState({
  //     [name]: value || "",
  //     [`${name}Error`]: "",
  //   }, () => {
  //     if (name === "categoryId" && value) {
  //       this.fetchSizes(value);
  //       this.fetchProductTypes(value);
  //       this.fetchBundles(value);
  //       this.buildTotalPagesList(value);
  //       this.buildTemplateSlots(value); // ← add this
  //     }
  //   });
  // };

  handleChange = (e) => {
    const { name, value } = e.target;

    // ── Category change — warn only if themeCategoryId already selected ──
    if (name === "categoryId") {
      if (this.state.themeCategoryId) {
        this.confirmReset(
          "Changing the category will reset all progress. Continue?",
          () => {
            this.setState({
              [name]: value || "",
              [`${name}Error`]: "",
              themeCategoryId: "",
              themeCategoryIdError: "",
              sizeId: "",
              sizeIdError: "",
              totalPages: "",
              totalPagesError: "",
              numberOfPages: "20",
              numberOfPagesError: "",
              selectedProductTypes: [],
              selectedProductTypesError: "",
              selectedBundles: [],
              selectedBundlesError: "",
              bundlesList: [],
              sizesList: [],
              productTypesList: [],
              layoutsList: [],
              themeLabel: "",
              themeLabelError: "",
              description: "",
              descriptionError: "",
              templateImages: [],
              previewImage: null,
              thumbnailImage: null,
            }, () => {
              if (value) {
                this.fetchSizes(value);
                this.fetchProductTypes(value);
                this.buildTotalPagesList(value, "20");
                this.buildTemplateSlots(value, "20");
                this.fetchLayouts(value);
                this.fetchBundles(value);
              }
            });
          }
        );
      } else {
        this.setState({ [name]: value || "", [`${name}Error`]: "", numberOfPages: "20" }, () => {
          if (value) {
            this.fetchSizes(value);
            this.fetchProductTypes(value);
            this.buildTotalPagesList(value, "20");
            this.buildTemplateSlots(value, "20");
            this.fetchLayouts(value);
            this.fetchBundles(value);
          }
        });
      }
      return;
    }

    // ── Theme Category change — warn only if sizeId already selected ──
    if (name === "themeCategoryId") {
      if (this.state.sizeId) {
        this.confirmReset(
          "Changing the theme category will reset size, images and selections. Continue?",
          () => {
            this.setState({
              [name]: value || "",
              [`${name}Error`]: "",
              sizeId: "",
              sizeIdError: "",
              totalPages: "",
              totalPagesError: "",
              selectedProductTypes: [],
              selectedProductTypesError: "",
              selectedBundles: [],
              selectedBundlesError: "",
              themeLabel: "",
              themeLabelError: "",
              description: "",
              descriptionError: "",
              // Keep slot structure intact — only clear uploaded file data
              templateImages: this.state.templateImages.map((slot) => ({
                ...slot,
                file: null,
                preview: null,
                dimensions: null,
                generatedFileName: "",
                layoutId: "",
                layoutIdError: "",
              })),
              previewImage: null,
              thumbnailImage: null,
            });
          }
        );
      } else {
        // No sizeId yet — just update and regenerate filenames if any slots have files
        this.setState({ [name]: value || "", [`${name}Error`]: "" }, () => {
          const hasFiles = this.state.templateImages.some((s) => s.file);
          if (hasFiles) {
            this.setState((prev) => ({
              templateImages: prev.templateImages.map((slot) => {
                if (!slot.file) return slot;
                const generatedName = this.generateAssetFileName(slot);
                const renamedFile = new File([slot.file], generatedName, { type: slot.file.type });
                return { ...slot, file: renamedFile, generatedFileName: generatedName };
              }),
            }));
          }
        });
      }
      return;
    }

    // ── Theme Label change — regenerate filenames live; warn+clear only if files are uploaded ──
    if (name === "themeLabel") {
      if (this.state.templateImages.some((s) => s.file)) {
        this.confirmReset(
          "Changing the theme label will reset all uploaded images. Continue?",
          () => {
            this.setState({
              [name]: value || "",
              [`${name}Error`]: "",
              // Keep slot structure intact — only clear uploaded file data
              templateImages: this.state.templateImages.map((slot) => ({
                ...slot,
                file: null,
                preview: null,
                dimensions: null,
                generatedFileName: "",
              })),
              previewImage: null,
              thumbnailImage: null,
            });
          }
        );
      } else {
        // No files yet — update label and regenerate any filenames if slots exist
        this.setState({ [name]: value || "", [`${name}Error`]: "" }, () => {
          const hasFiles = this.state.templateImages.some((s) => s.file);
          if (hasFiles) {
            this.setState((prev) => ({
              templateImages: prev.templateImages.map((slot) => {
                if (!slot.file) return slot;
                const generatedName = this.generateAssetFileName(slot);
                const renamedFile = new File([slot.file], generatedName, { type: slot.file.type });
                return { ...slot, file: renamedFile, generatedFileName: generatedName };
              }),
            }));
          }
        });
      }
      return;
    }

    // ── Size change — warn only if templateImages have uploaded files ──
    if (name === "sizeId") {
      if (this.state.templateImages.some((s) => s.file)) {
        this.confirmReset(
          "Changing the size will reset all uploaded images. Continue?",
          () => {
            this.setState({
              [name]: value || "",
              [`${name}Error`]: "",
              totalPages: "",
              totalPagesError: "",
              selectedProductTypes: [],
              selectedProductTypesError: "",
              selectedBundles: [],
              selectedBundlesError: "",
              templateImages: this.state.templateImages.map((slot) => ({
                ...slot,
                file: null,
                preview: null,
                dimensions: null,
                generatedFileName: "",
              })),
              previewImage: null,
              thumbnailImage: null,
            });
          }
        );
      } else {
        // No uploaded files — just update sizeId and regenerate any existing filenames
        this.setState({ [name]: value || "", [`${name}Error`]: "" }, () => {
          const hasFiles = this.state.templateImages.some((s) => s.file);
          if (hasFiles) {
            this.setState((prev) => ({
              templateImages: prev.templateImages.map((slot) => {
                if (!slot.file) return slot;
                const generatedName = this.generateAssetFileName(slot);
                const renamedFile = new File([slot.file], generatedName, { type: slot.file.type });
                return { ...slot, file: renamedFile, generatedFileName: generatedName };
              }),
            }));
          }
        });
      }
      return;
    }

    // ── Default ──
    this.setState({
      [name]: value || "",
      [`${name}Error`]: "",
    });
  };
  // handleChange = (e) => {
  //   const { name, value } = e.target;
  //   this.setState({
  //     [name]: value || "",
  //     [`${name}Error`]: "",
  //   }, () => {
  //     if (name === "categoryId" && value) {
  //       // Reset all dependent state
  //       this.setState({
  //         themeCategoryId: "",
  //         themeCategoryIdError: "",
  //         sizeId: "",
  //         sizeIdError: "",
  //         totalPages: "",
  //         totalPagesError: "",
  //         selectedProductTypes: [],
  //         selectedProductTypesError: "",
  //         selectedBundles: [],
  //         selectedBundlesError: "",
  //         bundlesList: [],
  //         sizesList: [],
  //         productTypesList: [],
  //         themeLabel: "",
  //         themeLabelError: "",
  //         description: "",
  //         descriptionError: "",
  //         templateImages: [],
  //         previewImage: null,
  //         previewImageError: "",
  //         thumbnailImage: null,
  //         thumbnailImageError: "",
  //       });

  //       // Fetch dependent data
  //       this.fetchSizes(value);
  //       this.fetchProductTypes(value);
  //       this.fetchBundles(value);
  //       this.buildTotalPagesList(value);
  //       this.buildTemplateSlots(value);
  //       this.fetchLayouts(value);
  //     }
  //   });
  // };

  handleProductTypesChange = (selected) => {
    this.setState({
      selectedProductTypes: selected || [],
      selectedProductTypesError: "",
    });
  };

  handleBundlesChange = (selected) => {
    this.setState({
      selectedBundles: selected || [],
      selectedBundlesError: "",
    });
  };

  handleSnackbar = (isOpen, message, severity) => {
    this.setState({ isOpenSnackbar: isOpen, snackbarMessage: message, snackbarSeverity: severity });
  };


  handleTemplateImageUpload = (slotKey, file) => {
    if (!file) return;
    const preview = URL.createObjectURL(file);

    const img = new Image();
    img.onload = () => {
      // ── Aspect ratio validation ──
      const { sizesList, sizeId, categoryId, templateImages } = this.state;
      const sizeItem = sizesList.find((s) => s.id == sizeId);
      const sizeLabel = sizeItem?.label || sizeItem?.userLabel || "";
      const slot = templateImages.find((s) => s.slotKey === slotKey);
      const expectedRatio = slot
        ? getExpectedAspectRatio(sizeId, slot.pageNumber, slot.slotNumber, categoryId)
        : null;

      if (expectedRatio) {
        const actualRatio = img.width / img.height;
        const diff = Math.abs(actualRatio - expectedRatio);
        if (diff > ASPECT_RATIO_TOLERANCE) {
          URL.revokeObjectURL(preview);
          this.handleSnackbar(
            true,
            `Wrong aspect ratio for slot ${slotKey}. ` +
            `Expected ~${expectedRatio.toFixed(4)} (±${ASPECT_RATIO_TOLERANCE}), ` +
            `got ${actualRatio.toFixed(4)} (${img.width}×${img.height}px).`,
            "error"
          );
          return;
        }
      }

      this.setState((prev) => ({
        templateImages: prev.templateImages.map((slot) => {
          if (slot.slotKey !== slotKey) return slot;
          const updatedSlot = {
            ...slot,
            file,
            preview,
            dimensions: { width: img.width, height: img.height },
          };
          // Generate name after slot is updated
          return updatedSlot;
        }),
      }), () => {
        // Re-generate filename after state is updated (so layoutId etc are current)
        this.setState((prev) => ({
          templateImages: prev.templateImages.map((slot) => {
            if (slot.slotKey !== slotKey) return slot;
            const generatedName = this.generateAssetFileName(slot);
            const renamedFile = new File([slot.file], generatedName, { type: slot.file.type });
            return { ...slot, file: renamedFile, generatedFileName: generatedName };
          }),
        }));
      });
    };
    img.src = preview;
  };

  handleTemplateImageRemove = (slotKey) => {
    this.setState((prev) => ({
      templateImages: prev.templateImages.map((slot) =>
        slot.slotKey === slotKey ? { ...slot, file: null, preview: null } : slot
      ),
    }));
  };


  // Returns { collageInfoList, exportWidth, exportHeight } using actual pixel export dimensions
  getCollageOverlay = (layoutId, pageNumber) => {
    const { sizesList, sizeId, layoutsList, categoryId } = this.state;
    if (!layoutId) return null;

    const sizeItem = sizesList.find((s) => s.id == sizeId);
    const sizeAlias = sizeItem?.alias || sizeItem?.userLabel?.toLowerCase().replace(/\s+/g, "") || "ml";

    const layoutItem = layoutsList.find((l) => String(l.layoutId) === String(layoutId));
    if (!layoutItem) return null;
    const layoutNo = (layoutItem.layoutNo || "").replace(/\s+/g, "");

    const fnName = `${sizeAlias}_${layoutNo}`;
    if (typeof this[fnName] !== "function") return null;

    // Derive real export pixel dimensions from the same source as getExpectedAspectRatio
    const id = parseInt(categoryId);
    const totalPages = { 2: 24, 6: 12, 9: 1 }[id] || 0;
    const isFrontCover = pageNumber === 1;
    const isBackCover = pageNumber === totalPages && totalPages > 1;
    const isRightPage = totalPages > 1 && pageNumber % 2 === 0;

    let exportW = 3508, exportH = 2400; // sensible default (landscape inner)

    if (id === 2) {
      if (sizeItem?.id == 2) {
        if (isFrontCover) { exportW = 3796; exportH = 3000; }
        else if (isBackCover) { exportW = 4010; exportH = 3000; }
        else { exportW = 3508; exportH = 2400; }
      } else if (sizeItem?.id == 4) {
        if (isFrontCover) { exportW = 2737; exportH = 3000; }
        else if (isBackCover) { exportW = 2961; exportH = 3000; }
        else { exportW = 2400; exportH = 2400; }
      }
    } else if (id === 6) {
      if (sizeItem?.id === 15) { exportW = 3600; exportH = 3600; }
      else { exportW = 3600; exportH = 5400; }
    } else if (id === 9) {
      exportW = 2550;
      exportH = sizeItem?.id === 23 ? 1125 : 1050;
    }

    const collageInfoList = this[fnName]({ exportWidth: exportW, exportHeight: exportH, isRightPage });
    return { collageInfoList, exportWidth: exportW, exportHeight: exportH };
  };



  isFormValid = () => {
    let isValid = true;
    const errors = {};

    if (!this.state.categoryId) {
      isValid = false;
      errors.categoryIdError = "Please select a category.";
    }
    if (!this.state.themeCategoryId) {
      isValid = false;
      errors.themeCategoryIdError = "Please select a theme category.";
    }
    if (!this.state.sizeId) {
      isValid = false;
      errors.sizeIdError = "Please select a size.";
    }
    if (!this.state.totalPages) {
      isValid = false;
      errors.totalPagesError = "Please select total pages.";
    }
    if (!this.state.selectedProductTypes || this.state.selectedProductTypes.length === 0) {
      isValid = false;
      errors.selectedProductTypesError = "Please select at least one product type.";
    }
    if (!this.state.themeLabel) {
      isValid = false;
      errors.themeLabelError = "Please enter theme label.";
    }
    if (!this.state.description) {
      isValid = false;
      errors.descriptionError = "Please enter description.";
    }

    // Preview — required for all
    if (!this.state.previewImage) {
      isValid = false;
      errors.previewImageError = "Please upload preview image.";
    }

    // Thumbnail — required for Calendar only
    if (this.state.categoryId == 6 && !this.state.thumbnailImage) {
      isValid = false;
      errors.thumbnailImageError = "Please upload thumbnail image.";
    }

    // Validate all template image slots are filled
    const emptySlots = this.state.templateImages.filter((slot) => !slot.file);
    if (emptySlots.length > 0) {
      isValid = false;
      this.handleSnackbar(
        true,
        `Please upload all template images. ${emptySlots.length} slot(s) are empty: ${emptySlots.map((s) => `Page ${s.pageNumber} - ${s.slotLabel}`).join(", ")}`,
        "error"
      );
    }

    const emptyLayouts = this.state.templateImages.filter((slot) => !slot.layoutId);
    if (emptyLayouts.length > 0) {
      isValid = false;
      this.handleSnackbar(
        true,
        `Please select layout for all slots. ${emptyLayouts.length} slot(s) missing: ${emptyLayouts.map((s) => `Page ${s.pageNumber} - ${s.slotLabel}`).join(", ")}`,
        "error"
      );
    }

    this.setState(errors);
    return isValid;
  };

  submitForm = async (e) => {
    e.preventDefault();
    if (!this.isFormValid()) return;

    this.setState({ isLoading: true });

    const data = new FormData();
    data.append("recordId", this.state.recordId);
    data.append("categoryId", this.state.categoryId);
    data.append("themeCategoryId", this.state.themeCategoryId);
    data.append("sizeId", this.state.sizeId);
    data.append("totalPages", this.state.totalPages);
    data.append("themeLabel", this.state.themeLabel);
    data.append("description", this.state.description);



    // Product Types — list
    this.state.selectedProductTypes.forEach((pt) => {
      data.append("productTypeId", pt.id);
    });

    // Bundles — list
    this.state.selectedBundles && this.state.selectedBundles.forEach((b) => {
      data.append("bundleId", b.id);
    });

    // Template Images — split into AppAssets and PrintAssets
    const appAssets = this.state.templateImages.filter((s) => s.slotNumber === 1);
    const printAssets = this.state.templateImages.filter((s) => s.slotNumber === 2);

    appAssets.forEach((slot) => {
      data.append("appAssets", slot.file);
      data.append("appAssetLayoutIds", slot.layoutId);
    });

    printAssets.forEach((slot) => {
      data.append("printAssets", slot.file);
      data.append("printAssetLayoutIds", slot.layoutId);
    });

    // Preview image — required for all categories
    if (this.state.previewImage) {
      data.append("previewFile", this.state.previewImage.file);
    }

    // Thumbnail image — Calendar only
    if (this.state.categoryId == 6 && this.state.thumbnailImage) {
      data.append("thumbnailFile", this.state.thumbnailImage.file);
    }

    const res = await HttpRequest(
      "POST",
      `${process.env.REACT_APP_API_DOMAIN}/${process.env.REACT_APP_SUB_API_NAME}/common/C15ALLThemesSave`,
      data,
      "authorize"
    );

    if (res.isSuccess) {
      this.handleSnackbar(true, "Saved Successfully", "success");
      this.clearForm();
    } else {
      if (res.statusCode === 401) this.setState({ isLoginMenu: true });
      else this.handleSnackbar(true, res.message || "Save failed", "error");
    }

    this.setState({ isLoading: false });
  };

  getGeneratedLabel = () => {
    const { themeLabel, sizesList, sizeId, selectedProductTypes, selectedBundles, categoryId, categoriesList } = this.state;

    if (!themeLabel) return "";

    const sizeItem = sizesList.find((s) => s.id == sizeId);
    const sizeLabel = sizeItem ? (sizeItem.label || sizeItem.userLabel || "") : "";

    const labels = [];

    const bundlesExcludingOne = selectedBundles
      ? selectedBundles.filter((b) => b.value !== 1)
      : [];

    const hasBundleOf1 = selectedBundles
      ? selectedBundles.some((b) => b.value === 1)
      : false;

    // ── Calendar: use category label instead of product type ──
    if (categoryId == 6) {
      const categoryItem = categoriesList.find((c) => c.id == categoryId);
      const categoryLabel = categoryItem ? (categoryItem.label || categoryItem.userLabel || "") : "";

      let base = `${themeLabel} Theme`;
      if (sizeLabel) base += ` - ${sizeLabel}`;
      if (categoryLabel) base += ` - ${categoryLabel}`;

      if (bundlesExcludingOne.length === 0) {
        labels.push(base);
      } else if (hasBundleOf1) {
        labels.push(base);
        bundlesExcludingOne.forEach((bundle) => {
          labels.push(`${base} - ${bundle.label}`);
        });
      } else {
        bundlesExcludingOne.forEach((bundle) => {
          labels.push(`${base} - ${bundle.label}`);
        });
      }

      return labels.join("\n");
    }

    // ── All other categories: use product types ──
    const productTypes = selectedProductTypes && selectedProductTypes.length > 0
      ? selectedProductTypes
      : [null];

    productTypes.forEach((pt) => {
      let base = `${themeLabel} Theme`;
      if (sizeLabel) base += ` - ${sizeLabel}`;
      if (pt) base += ` - ${pt.label}`;

      if (bundlesExcludingOne.length === 0) {
        labels.push(base);
      } else if (hasBundleOf1) {
        labels.push(base);
        bundlesExcludingOne.forEach((bundle) => {
          labels.push(`${base} - ${bundle.label}`);
        });
      } else {
        bundlesExcludingOne.forEach((bundle) => {
          labels.push(`${base} - ${bundle.label}`);
        });
      }
    });

    return labels.join("\n");
  };


  handleReplicatePage1ToAll = () => {
    const page1AppAsset = this.state.templateImages.find(
      (s) => s.pageNumber === 1 && s.slotNumber === 1
    );
    const page1PrintAsset = this.state.templateImages.find(
      (s) => s.pageNumber === 1 && s.slotNumber === 2
    );

    if (!page1AppAsset?.file || !page1PrintAsset?.file) {
      this.handleSnackbar(true, "Please upload both Page 1 images first.", "error");
      return;
    }

    this.setState((prev) => ({
      templateImages: prev.templateImages.map((slot) => {
        if (slot.pageNumber === 1) return slot; // keep page 1 as is

        if (slot.slotNumber === 1) {
          // Replicate App Asset
          return {
            ...slot,
            file: page1AppAsset.file,
            preview: page1AppAsset.preview,
            dimensions: page1AppAsset.dimensions,
          };
        } else {
          // Replicate Print Asset
          return {
            ...slot,
            file: page1PrintAsset.file,
            preview: page1PrintAsset.preview,
            dimensions: page1PrintAsset.dimensions,
          };
        }
      }),
    }), () => {
      this.handleSnackbar(true, "Page 1 images replicated to all pages successfully.", "success");
    });
  };


  clearForm = () => {
    this.setState({
      recordId: 0,
      categoryId: "",
      categoryIdError: "",
      themeCategoryId: "",
      themeCategoryIdError: "",
      sizeId: "",
      sizeIdError: "",
      totalPages: "",
      totalPagesError: "",
      selectedProductTypes: [],
      selectedProductTypesError: "",
      bundleId: "",
      bundleIdError: "",
      description: "",
      descriptionError: "",
      themeLabel: "",
      themeLabelError: "",
      previewImage: null,        // { file, preview, dimensions }
      previewImageError: "",
      thumbnailImage: null,      // { file, preview, dimensions }
      thumbnailImageError: "",
      templateImages: [],
    });
  };

  handlePreviewImageUpload = (file) => {
    if (!file) return;
    const preview = URL.createObjectURL(file);
    const img = new Image();
    img.onload = () => {
      this.setState({
        previewImage: { file, preview, dimensions: { width: img.width, height: img.height } },
        previewImageError: "",
      });
    };
    img.src = preview;
  };

  handleThumbnailImageUpload = (file) => {
    if (!file) return;
    const preview = URL.createObjectURL(file);
    const img = new Image();
    img.onload = () => {
      this.setState({
        thumbnailImage: { file, preview, dimensions: { width: img.width, height: img.height } },
        thumbnailImageError: "",
      });
    };
    img.src = preview;
  };

  handlePreviewImageRemove = () => {
    this.setState({ previewImage: null, previewImageError: "" });
  };

  handleThumbnailImageRemove = () => {
    this.setState({ thumbnailImage: null, thumbnailImageError: "" });
  };

  onViewAllButtonClick = () => {
    window.location = "#/F15AllThemedAssetsView";
  };


  generateAssetFileName = (slot) => {

    console.log("generateAssetFileName called for slot:", slot.slotKey);
    console.log("slot.layoutId:", slot.layoutId);
    const {
      categoryId, sizeId, themeLabel,
      themeCategoryId, categoriesList, sizesList, themeCategoriesList, layoutsList,
    } = this.state;

    const pageNo = slot.pageNumber;
    const assetTypePrefix = slot.slotNumber === 1 ? "ic" : "fl";

    const categoryItem = categoriesList.find((c) => c.id == categoryId);
    const categoryAlias = categoryItem?.alias || "pb";

    const sizeItem = sizesList.find((s) => s.id == sizeId);
    const sizeAlias = sizeItem?.alias || sizeItem?.userLabel?.toLowerCase().replace(/\s+/g, "") || "ml";

    const themeCategoryItem = themeCategoriesList.find((t) => (t.categoryId || t.id) == themeCategoryId);
    const themeCategoryLabel = (themeCategoryItem?.categoryLabel || themeCategoryItem?.label || "")
      .toLowerCase()
      .replace(/\s+/g, "")
      .replace(/[^a-z0-9]/g, "");

    const cleanThemeLabel = (themeLabel || "")
      .toLowerCase()
      .replace(/\s+/g, "")
      .replace(/[^a-z0-9]/g, "");

    // ── Use slot.layoutId directly (not from state loop) ──
    const layoutItem = layoutsList.find((l) => String(l.layoutId) === String(slot.layoutId));
    const layoutNo = layoutItem?.layoutNo || "0";

    console.log("layoutItem:", layoutItem);
    console.log("layoutNo:", layoutNo);

    // const ext = slot.file?.name?.split(".").pop() || "png";
    const mimeToExt = { "image/png": "png", "image/jpeg": "jpg", "image/jpg": "jpg", "image/gif": "gif" };
    const ext = mimeToExt[slot.file?.type] || "png";

    return `${pageNo}_${assetTypePrefix}_tm_${categoryAlias}_${sizeAlias}_${themeCategoryLabel}_${cleanThemeLabel}_${layoutNo}.${ext}`;
  };

  confirmReset = (message, onConfirm) => {
    if (window.confirm(message)) {
      onConfirm();
    }
  };

  handleNumberOfPagesChange = (e) => {
    const { value } = e.target;
    if (this.state.templateImages.some((s) => s.file)) {
      this.confirmReset(
        "Changing the number of pages will reset all uploaded images. Continue?",
        () => {
          this.setState({ numberOfPages: value, numberOfPagesError: "" }, () => {
            this.buildTotalPagesList(this.state.categoryId, value);
            this.buildTemplateSlots(this.state.categoryId, value);
          });
        }
      );
    } else {
      this.setState({ numberOfPages: value, numberOfPagesError: "" }, () => {
        this.buildTotalPagesList(this.state.categoryId, value);
        this.buildTemplateSlots(this.state.categoryId, value);
      });
    }
  };

  render() {
    const { classes } = this.props;
    const {
      categoriesList, themeCategoriesList, sizesList,
      totalPagesList, productTypesList, bundlesList,
      selectedProductTypes,
    } = this.state;

    return (
      <Fragment>
        <LoginMenu
          reload={this.state.isReload}
          open={this.state.isLoginMenu}
          handleClose={() => this.setState({ isLoginMenu: false })}
        />
        <CustomizedSnackbar
          isOpen={this.state.isOpenSnackbar}
          message={this.state.snackbarMessage}
          severity={this.state.snackbarSeverity}
          handleCloseSnackbar={() => this.handleSnackbar(false, "", "")}
          autoHideDuration={3000}
        />

        <Grid
          container
          xs={12}
          direction="column"
          justifyContent="center"
          alignItems="center"
          style={{ padding: 10 }}
        >
          <Toolbar>
            <NavBar isAuthorize title="Add New Theme" />
          </Toolbar>

          <Card
            style={{
              width: "98%",
              paddingBottom: 100,
              paddingLeft: 20,
              paddingRight: 20,
            }}
          >
            <CardContent>
              <Typography variant="h5" color="primary" style={{ fontWeight: 700, marginBottom: 8 }}>
                {this.state.recordId == 0 ? "Add New Theme" : "Edit Theme"}
              </Typography>
              <Divider style={{ marginBottom: 24 }} />

              <Grid container spacing={2}>

                {/* ── Category ── */}
                <Grid item xs={12} sm={6}>
                  <TextField
                    select
                    id="categoryId"
                    name="categoryId"
                    fullWidth
                    label="Category *"
                    variant="outlined"
                    onChange={this.handleChange}
                    value={this.state.categoryId}
                    error={!!this.state.categoryIdError}
                    helperText={this.state.categoryIdError}
                    disabled={this.state.categoriesLoading}
                    size="small"
                  >
                    {categoriesList.map((item) => (
                      <MenuItem key={item.id} value={item.id}>
                        {item.label || item.userLabel || ""}
                      </MenuItem>
                    ))}
                  </TextField>
                </Grid>

                {/* ── Theme Category ── */}
                <Grid item xs={12} sm={6}>
                  <TextField
                    select
                    id="themeCategoryId"
                    name="themeCategoryId"
                    fullWidth
                    label="Theme Category *"
                    variant="outlined"
                    onChange={this.handleChange}
                    value={this.state.themeCategoryId}
                    error={!!this.state.themeCategoryIdError}
                    helperText={this.state.themeCategoryIdError}
                    disabled={this.state.themeCategoriesLoading}
                    size="small"
                  >
                    {themeCategoriesList.map((item) => {
                      const isDisabled = [2, 6].includes(parseInt(this.state.categoryId)) && item.id === 3;
                      return (
                        <MenuItem key={item.id} value={item.id} disabled={isDisabled}>
                          {item.categoryLabel || item.label || ""}{isDisabled ? " (Not available for this category)" : ""}
                        </MenuItem>
                      );
                    })}
                  </TextField>
                </Grid>
                {/* ── Number of Pages — only for Themed Photobooks (categoryId == 2) ── */}
                {this.state.categoryId == 2 && (
                  <Grid item xs={12} sm={6}>
                    <TextField
                      select
                      id="numberOfPages"
                      name="numberOfPages"
                      fullWidth
                      label="Number of Pages *"
                      variant="outlined"
                      size="small"
                      value={this.state.numberOfPages}
                      onChange={this.handleNumberOfPagesChange}
                      error={!!this.state.numberOfPagesError}
                      helperText={this.state.numberOfPagesError}
                    >
                      <MenuItem value="20">20 Pages</MenuItem>
                      <MenuItem value="10">10 Pages</MenuItem>
                    </TextField>
                  </Grid>
                )}

                {/* ── Theme Label ── */}
                <Grid item xs={12} sm={6}>
                  <TextField
                    autoComplete="off"
                    id="themeLabel"
                    name="themeLabel"
                    label="Theme Label *"
                    variant="outlined"
                    onChange={this.handleChange}
                    value={this.state.themeLabel}
                    error={!!this.state.themeLabelError}
                    helperText={this.state.themeLabelError}
                    fullWidth
                    inputProps={{ maxLength: 250 }}
                    size="small"
                  />
                </Grid>

                {/* ── Size ── */}
                <Grid item xs={12} sm={6}>
                  <TextField
                    select
                    id="sizeId"
                    name="sizeId"
                    fullWidth
                    label="Size *"
                    variant="outlined"
                    onChange={this.handleChange}
                    value={this.state.sizeId}
                    error={!!this.state.sizeIdError}
                    helperText={this.state.sizeIdError}
                    disabled={this.state.sizesLoading}
                    size="small"
                  >
                    {sizesList.map((item) => (
                      <MenuItem key={item.id} value={item.id}>
                        {item.label || item.userLabel || ""}
                      </MenuItem>
                    ))}
                  </TextField>
                </Grid>



                {/* ── Product Type (Multi-select) ── */}
                <Grid item xs={12} sm={6}>

                  <Select
                    isMulti
                    value={selectedProductTypes}
                    name="productTypesList"
                    options={productTypesList}
                    onChange={this.handleProductTypesChange}
                    className="basic-multi-select"
                    size="small"
                    classNamePrefix="select"
                    placeholder="Select product types..."
                    isLoading={this.state.productTypesLoading}
                    styles={{
                      option: (base) => ({
                        ...base,
                        background: "#FFFFFF",
                        backgroundColor: "#FFFFFF",
                      }),
                      control: (base) => ({
                        ...base,
                        borderColor: this.state.selectedProductTypesError ? "#f44336" : base.borderColor,
                        minHeight: 56,
                      }),
                    }}
                  />
                  {this.state.selectedProductTypesError && (
                    <Typography variant="caption" style={{ color: "#f44336", marginTop: 4, display: "block" }}>
                      {this.state.selectedProductTypesError}
                    </Typography>
                  )}
                </Grid>

                {/* ── Bundles ── */}
                {this.state.categoryId == 9 && (
                  <Grid item xs={12} sm={6}>

                    <Select
                      isMulti
                      value={this.state.selectedBundles}
                      name="bundlesList"
                      options={this.state.bundlesList}
                      onChange={this.handleBundlesChange}
                      className="basic-multi-select"
                      classNamePrefix="select"
                      placeholder="Select bundles..."
                      isLoading={this.state.bundlesLoading}
                      styles={{
                        option: (base) => ({
                          ...base,
                          background: "#FFFFFF",
                          backgroundColor: "#FFFFFF",
                        }),
                        control: (base) => ({
                          ...base,
                          borderColor: this.state.selectedBundlesError ? "#f44336" : base.borderColor,
                          minHeight: 56,
                        }),
                      }}
                    />
                    {this.state.selectedBundlesError && (
                      <Typography variant="caption" style={{ color: "#f44336", marginTop: 4, display: "block" }}>
                        {this.state.selectedBundlesError}
                      </Typography>
                    )}
                  </Grid>
                )}


                {/* ── Description ── */}
                <Grid item xs={12} sm={6}>
                  <TextField
                    autoComplete="off"
                    id="description"
                    name="description"
                    label="Description *"
                    variant="outlined"
                    onChange={this.handleChange}
                    value={this.state.description}
                    error={!!this.state.descriptionError}
                    helperText={this.state.descriptionError}
                    fullWidth
                    multiline
                    rows={2}
                    inputProps={{ maxLength: 500 }}
                    size="small"
                  />
                </Grid>

                {/* ── PREVIEW & THUMBNAIL IMAGES ── */}
                {this.state.categoryId && (
                  <Grid item xs={12}>
                    <Divider style={{ margin: "16px 0" }} />
                    <Typography variant="h6" color="primary" style={{ fontWeight: 600, marginBottom: 16 }}>
                      {this.state.categoryId == 6 ? "Preview & Thumbnail Images" : "Preview Image"}
                    </Typography>

                    <Grid container spacing={2}>

                      {/* ── Preview Image — required for all categories ── */}
                      <Grid item xs={12} sm={6} md={4}>
                        <Typography
                          variant="subtitle2"
                          style={{ fontWeight: 600, color: "#555", marginBottom: 8 }}
                        >
                          Preview Image <span style={{ color: "#f44336" }}>*</span>
                        </Typography>

                        <input
                          type="file"
                          accept="image/*"
                          id="preview-image-upload"
                          style={{ display: "none" }}
                          onChange={(e) => {
                            const file = e.target.files[0];
                            if (file) this.handlePreviewImageUpload(file);
                            e.target.value = "";
                          }}
                        />

                        <label htmlFor="preview-image-upload" style={{ cursor: "pointer", display: "block" }}>
                          <Tooltip title={this.state.previewImage ? "Click to replace" : "Click to upload"}>
                            <div
                              style={{
                                width: "100%",
                                height: 180,
                                backgroundColor: "#f5f5f5",
                                border: this.state.previewImage
                                  ? "1px solid #e0e0e0"
                                  : this.state.previewImageError
                                    ? "2px dashed #f44336"
                                    : "2px dashed #ccc",
                                borderRadius: 8,
                                overflow: "hidden",
                                display: "flex",
                                alignItems: "center",
                                justifyContent: "center",
                                transition: "opacity 0.2s",
                              }}
                              onMouseEnter={(e) => e.currentTarget.style.opacity = "0.85"}
                              onMouseLeave={(e) => e.currentTarget.style.opacity = "1"}
                            >
                              {this.state.previewImage ? (
                                <img
                                  src={this.state.previewImage.preview}
                                  alt="preview"
                                  style={{ width: "100%", height: "100%", objectFit: "contain" }}
                                />
                              ) : (
                                <div style={{ textAlign: "center", color: "#bbb" }}>
                                  <img src={ckLogo} alt="preview" style={{ width: "20%", height: "20%", objectFit: "contain" }} />
                                  <Typography variant="caption" style={{ color: "#bbb", display: "block", marginTop: 4 }}>
                                    Click to upload Preview
                                  </Typography>
                                </div>
                              )}
                            </div>
                          </Tooltip>
                        </label>

                        {this.state.previewImage && (
                          <Box mt={1}>
                            <Typography
                              variant="caption"
                              color="textSecondary"
                              style={{
                                display: "block",
                                whiteSpace: "nowrap",
                                overflow: "hidden",
                                textOverflow: "ellipsis",
                              }}
                              title={this.state.previewImage.file.name}
                            >
                              📄 {this.state.previewImage.file.name}
                            </Typography>
                            {this.state.previewImage.dimensions && (
                              <Typography variant="caption" style={{ color: "#888", display: "block" }}>
                                📐 {this.state.previewImage.dimensions.width} × {this.state.previewImage.dimensions.height} px
                              </Typography>
                            )}
                            <Box display="flex" justifyContent="flex-end">
                              <Tooltip title="Remove">
                                <IconButton
                                  size="small"
                                  onClick={this.handlePreviewImageRemove}
                                  style={{ color: "#f44336", padding: 4 }}
                                >
                                  <CloseIcon fontSize="small" />
                                </IconButton>
                              </Tooltip>
                            </Box>
                          </Box>
                        )}

                        {this.state.previewImageError && (
                          <Typography variant="caption" style={{ color: "#f44336", display: "block", marginTop: 4 }}>
                            {this.state.previewImageError}
                          </Typography>
                        )}
                      </Grid>

                      {/* ── Thumbnail Image — Calendar only ── */}
                      {this.state.categoryId == 6 && (
                        <Grid item xs={12} sm={6} md={4}>
                          <Typography
                            variant="subtitle2"
                            style={{ fontWeight: 600, color: "#555", marginBottom: 8 }}
                          >
                            Thumbnail Image <span style={{ color: "#f44336" }}>*</span>
                          </Typography>

                          <input
                            type="file"
                            accept="image/*"
                            id="thumbnail-image-upload"
                            style={{ display: "none" }}
                            onChange={(e) => {
                              const file = e.target.files[0];
                              if (file) this.handleThumbnailImageUpload(file);
                              e.target.value = "";
                            }}
                          />

                          <label htmlFor="thumbnail-image-upload" style={{ cursor: "pointer", display: "block" }}>
                            <Tooltip title={this.state.thumbnailImage ? "Click to replace" : "Click to upload"}>
                              <div
                                style={{
                                  width: "100%",
                                  height: 180,
                                  backgroundColor: "#f5f5f5",
                                  border: this.state.thumbnailImage
                                    ? "1px solid #e0e0e0"
                                    : this.state.thumbnailImageError
                                      ? "2px dashed #f44336"
                                      : "2px dashed #ccc",
                                  borderRadius: 8,
                                  overflow: "hidden",
                                  display: "flex",
                                  alignItems: "center",
                                  justifyContent: "center",
                                  transition: "opacity 0.2s",
                                }}
                                onMouseEnter={(e) => e.currentTarget.style.opacity = "0.85"}
                                onMouseLeave={(e) => e.currentTarget.style.opacity = "1"}
                              >
                                {this.state.thumbnailImage ? (
                                  <img
                                    src={this.state.thumbnailImage.preview}
                                    alt="thumbnail"
                                    style={{ width: "100%", height: "100%", objectFit: "contain" }}
                                  />
                                ) : (
                                  <div style={{ textAlign: "center", color: "#bbb" }}>
                                    <img src={ckLogo} alt="preview" style={{ width: "20%", height: "20%", objectFit: "contain" }} />
                                    <Typography variant="caption" style={{ color: "#bbb", display: "block", marginTop: 4 }}>
                                      Click to upload Thumbnail
                                    </Typography>
                                  </div>
                                )}
                              </div>
                            </Tooltip>
                          </label>

                          {this.state.thumbnailImage && (
                            <Box mt={1}>
                              <Typography
                                variant="caption"
                                color="textSecondary"
                                style={{
                                  display: "block",
                                  whiteSpace: "nowrap",
                                  overflow: "hidden",
                                  textOverflow: "ellipsis",
                                }}
                                title={this.state.thumbnailImage.file.name}
                              >
                                📄 {this.state.thumbnailImage.file.name}
                              </Typography>
                              {this.state.thumbnailImage.dimensions && (
                                <Typography variant="caption" style={{ color: "#888", display: "block" }}>
                                  📐 {this.state.thumbnailImage.dimensions.width} × {this.state.thumbnailImage.dimensions.height} px
                                </Typography>
                              )}
                              <Box display="flex" justifyContent="flex-end">
                                <Tooltip title="Remove">
                                  <IconButton
                                    size="small"
                                    onClick={this.handleThumbnailImageRemove}
                                    style={{ color: "#f44336", padding: 4 }}
                                  >
                                    <CloseIcon fontSize="small" />
                                  </IconButton>
                                </Tooltip>
                              </Box>
                            </Box>
                          )}

                          {this.state.thumbnailImageError && (
                            <Typography variant="caption" style={{ color: "#f44336", display: "block", marginTop: 4 }}>
                              {this.state.thumbnailImageError}
                            </Typography>
                          )}
                        </Grid>
                      )}
                    </Grid>
                  </Grid>
                )}

                {/* ── Generated Label Preview ── */}
                {(() => {
                  const generatedLabel = this.getGeneratedLabel();
                  if (!generatedLabel) return null;
                  return (
                    <Grid item xs={12}>
                      <TextField
                        label="Generated Product Label(s)"
                        variant="outlined"
                        fullWidth
                        size="small"
                        multiline
                        value={generatedLabel}
                        InputProps={{ readOnly: true }}
                        inputProps={{ style: { color: "#333", fontFamily: "monospace", fontSize: 13 } }}
                        helperText={`${generatedLabel.split("\n").length} label(s) will be generated`}
                      />
                    </Grid>
                  );
                })()}


                {/* ── IMAGE TEMPLATE ── */}
                {/* ── IMAGE TEMPLATE ── */}
                {this.state.templateImages.length > 0 && (
                  <Grid item xs={12}>
                    <Divider style={{ margin: "16px 0" }} />
                    <Box display="flex" alignItems="center" justifyContent="space-between" mb={2}>
                      <Typography variant="h6" color="primary" style={{ fontWeight: 600 }}>
                        Theme Image Template
                        <span style={{ fontSize: 13, color: "#888", fontWeight: 400, marginLeft: 8 }}>
                          ({this.state.templateImages.length} images — 2 per page)
                        </span>
                      </Typography>

                      {/* ── Replicate Button — Calendar only ── */}
                      {this.state.categoryId == 6 && (() => {
                        const page1App = this.state.templateImages.find(
                          (s) => s.pageNumber === 1 && s.slotNumber === 1
                        );
                        const page1Print = this.state.templateImages.find(
                          (s) => s.pageNumber === 1 && s.slotNumber === 2
                        );
                        return page1App?.file && page1Print?.file ? (
                          <Button
                            variant="contained"
                            color="primary"
                            size="small"
                            onClick={this.handleReplicatePage1ToAll}
                            style={{ backgroundColor: "#1976d2", color: "#fff", whiteSpace: "nowrap" }}
                          >
                            📋 Replicate Page 1 to All Pages
                          </Button>
                        ) : null;
                      })()}
                    </Box>
                    {Array.from(
                      { length: this.state.templateImages.length / 2 },
                      (_, pageIdx) => pageIdx + 1
                    ).map((pageNumber) => {
                      const pageSlots = this.state.templateImages.filter(
                        (s) => s.pageNumber === pageNumber
                      );
                      const appAssetSlot = pageSlots.find((s) => s.slotNumber === 1);
                      const printAssetSlot = pageSlots.find((s) => s.slotNumber === 2);

                      // Shared layoutId per page — use appAsset slot to store it
                      const pageLayoutId = appAssetSlot?.layoutId || "";
                      const pageLayoutError = appAssetSlot?.layoutIdError || "";

                      return (
                        <Box key={pageNumber} mb={2}>
                          <Typography
                            variant="subtitle2"
                            style={{ fontWeight: 600, color: "#555", marginBottom: 8 }}
                          >
                            Page {pageNumber}
                          </Typography>

                          <Grid container spacing={2} alignItems="stretch">

                            {/* ── Column 1: App Asset ── */}
                            <Grid item xs={12} sm={5} style={{ display: "flex" }}>
                              {appAssetSlot && (
                                <Card elevation={2} style={{ borderRadius: 8, width: "100%", display: "flex", flexDirection: "column" }}>
                                  <input
                                    type="file"
                                    accept="image/*"
                                    id={`template-upload-${appAssetSlot.slotKey}`}
                                    style={{ display: "none" }}
                                    onChange={(e) => {
                                      const file = e.target.files[0];
                                      if (file) this.handleTemplateImageUpload(appAssetSlot.slotKey, file);
                                      e.target.value = "";
                                    }}
                                  />
                                  <label htmlFor={`template-upload-${appAssetSlot.slotKey}`} style={{ cursor: "pointer", display: "block" }}>
                                    <Tooltip title={appAssetSlot.preview ? "Click to replace image" : "Click to upload image"}>
                                      <div
                                        style={{
                                          width: "100%",
                                          height: 160,
                                          backgroundColor: "#f5f5f5",
                                          border: appAssetSlot.preview ? "1px solid #e0e0e0" : "2px dashed #ccc",
                                          borderRadius: "8px 8px 0 0",
                                          overflow: "hidden",
                                          display: "flex",
                                          alignItems: "center",
                                          justifyContent: "center",
                                          transition: "opacity 0.2s",
                                        }}
                                        onMouseEnter={(e) => e.currentTarget.style.opacity = "0.85"}
                                        onMouseLeave={(e) => e.currentTarget.style.opacity = "1"}
                                      >
                                        {appAssetSlot.preview ? (
                                          <img
                                            src={appAssetSlot.preview}
                                            alt={appAssetSlot.slotKey}
                                            style={{ width: "100%", height: "100%", objectFit: "contain", backgroundColor: "#f5f5f5" }}
                                          />
                                        ) : (
                                          <div style={{ textAlign: "center", color: "#bbb" }}>
                                            <img src={ckLogo} alt="preview" style={{ width: "20%", height: "20%", objectFit: "contain" }} />
                                            <Typography variant="caption" style={{ color: "#bbb", display: "block", marginTop: 4 }}>
                                              Click to upload
                                            </Typography>
                                          </div>
                                        )}
                                      </div>
                                    </Tooltip>
                                  </label>
                                  <CardContent style={{ padding: "8px 10px" }}>
                                    <Typography variant="caption" style={{ fontWeight: 600, color: "#1976d2", display: "block", marginBottom: 2 }}>
                                      App Asset
                                    </Typography>
                                    {appAssetSlot.file && (
                                      <Typography
                                        variant="caption"
                                        color="textSecondary"
                                        style={{ display: "block", whiteSpace: "nowrap", overflow: "hidden", textOverflow: "ellipsis", marginBottom: 2 }}
                                        title={appAssetSlot.generatedFileName || appAssetSlot.file.name}
                                      >
                                        📄 {appAssetSlot.generatedFileName || appAssetSlot.file.name}
                                      </Typography>
                                    )}
                                    {appAssetSlot.dimensions && (
                                      <Typography variant="caption" style={{ color: "#888", display: "block", marginBottom: 4 }}>
                                        📐 {appAssetSlot.dimensions.width} × {appAssetSlot.dimensions.height} px
                                      </Typography>
                                    )}
                                    {appAssetSlot.preview && (
                                      <Box display="flex" justifyContent="flex-end">
                                        <Tooltip title="Remove image">
                                          <IconButton size="small" onClick={() => this.handleTemplateImageRemove(appAssetSlot.slotKey)} style={{ color: "#f44336", padding: 4 }}>
                                            <CloseIcon fontSize="small" />
                                          </IconButton>
                                        </Tooltip>
                                      </Box>
                                    )}
                                  </CardContent>
                                </Card>
                              )}
                            </Grid>

                            {/* ── Column 2: Print Asset ── */}
                            <Grid item xs={12} sm={5} style={{ display: "flex" }}>
                              {printAssetSlot && (
                                <Card elevation={2} style={{ borderRadius: 8, width: "100%", display: "flex", flexDirection: "column" }}>
                                  <input
                                    type="file"
                                    accept="image/*"
                                    id={`template-upload-${printAssetSlot.slotKey}`}
                                    style={{ display: "none" }}
                                    onChange={(e) => {
                                      const file = e.target.files[0];
                                      if (file) this.handleTemplateImageUpload(printAssetSlot.slotKey, file);
                                      e.target.value = "";
                                    }}
                                  />
                                  <label htmlFor={`template-upload-${printAssetSlot.slotKey}`} style={{ cursor: "pointer", display: "block" }}>
                                    <Tooltip title={printAssetSlot.preview ? "Click to replace image" : "Click to upload image"}>
                                      <div
                                        style={{
                                          width: "100%",
                                          height: 160,
                                          backgroundColor: "#f5f5f5",
                                          border: printAssetSlot.preview ? "1px solid #e0e0e0" : "2px dashed #ccc",
                                          borderRadius: "8px 8px 0 0",
                                          overflow: "hidden",
                                          display: "flex",
                                          alignItems: "center",
                                          justifyContent: "center",
                                          transition: "opacity 0.2s",
                                        }}
                                        onMouseEnter={(e) => e.currentTarget.style.opacity = "0.85"}
                                        onMouseLeave={(e) => e.currentTarget.style.opacity = "1"}
                                      >
                                        {printAssetSlot.preview ? (
                                          <img
                                            src={printAssetSlot.preview}
                                            alt={printAssetSlot.slotKey}
                                            style={{ width: "100%", height: "100%", objectFit: "contain", backgroundColor: "#f5f5f5" }}
                                          />
                                        ) : (
                                          <div style={{ textAlign: "center", color: "#bbb" }}>
                                            <img src={ckLogo} alt="preview" style={{ width: "20%", height: "20%", objectFit: "contain" }} />
                                            <Typography variant="caption" style={{ color: "#bbb", display: "block", marginTop: 4 }}>
                                              Click to upload
                                            </Typography>
                                          </div>
                                        )}
                                      </div>
                                    </Tooltip>
                                  </label>
                                  <CardContent style={{ padding: "8px 10px" }}>
                                    <Typography variant="caption" style={{ fontWeight: 600, color: "#e65100", display: "block", marginBottom: 2 }}>
                                      Print Asset
                                    </Typography>
                                    {printAssetSlot.file && (
                                      <Typography
                                        variant="caption"
                                        color="textSecondary"
                                        style={{ display: "block", whiteSpace: "nowrap", overflow: "hidden", textOverflow: "ellipsis", marginBottom: 2 }}
                                        title={printAssetSlot.generatedFileName || printAssetSlot.file.name}
                                      >
                                        📄 {printAssetSlot.generatedFileName || printAssetSlot.file.name}
                                      </Typography>
                                    )}
                                    {printAssetSlot.dimensions && (
                                      <Typography variant="caption" style={{ color: "#888", display: "block", marginBottom: 4 }}>
                                        📐 {printAssetSlot.dimensions.width} × {printAssetSlot.dimensions.height} px
                                      </Typography>
                                    )}
                                    {printAssetSlot.preview && (
                                      <Box display="flex" justifyContent="flex-end">
                                        <Tooltip title="Remove image">
                                          <IconButton size="small" onClick={() => this.handleTemplateImageRemove(printAssetSlot.slotKey)} style={{ color: "#f44336", padding: 4 }}>
                                            <CloseIcon fontSize="small" />
                                          </IconButton>
                                        </Tooltip>
                                      </Box>
                                    )}
                                  </CardContent>
                                </Card>
                              )}
                            </Grid>

                            {/* ── Column 3: Layout Picker ── */}
                            <Grid item xs={12} sm={2} style={{ display: "flex" }}>
                              <Card elevation={2} style={{
                                borderRadius: 8,
                                width: "100%",
                                display: "flex",
                                flexDirection: "column",
                                justifyContent: "flex-start",
                                padding: 12,
                              }}>
                                <Typography variant="caption" style={{ fontWeight: 600, color: "#555", display: "block", marginBottom: 8 }}>
                                  Layout
                                </Typography>

                                {/* ── Picture count dropdown ── */}
                                {(() => {
                                  const pictureOptions = [...new Set(
                                    this.state.layoutsList.map((l) => l.totalPictures).filter((v) => v != null)
                                  )].sort((a, b) => a - b);

                                  const selectedLayout = this.state.layoutsList.find(
                                    (l) => String(l.layoutId) === String(pageLayoutId)
                                  );

                                  return (
                                    <>
                                      <TextField
                                        select
                                        size="small"
                                        fullWidth
                                        variant="outlined"
                                        label="Pictures"
                                        value={selectedLayout?.totalPictures ?? ""}
                                        error={!!pageLayoutError}
                                        onChange={(e) => {
                                          // just opens the picker filtered to this count
                                          this.setState({ layoutPickerOpenPage: pageNumber, _pickerFilter: e.target.value });
                                        }}
                                        style={{ marginBottom: 8 }}
                                      >
                                        {pictureOptions.map((n) => (
                                          <MenuItem key={n} value={n}>
                                            {n} Picture{n !== 1 ? "s" : ""}
                                          </MenuItem>
                                        ))}
                                      </TextField>

                                      {/* Browse all layouts button */}
                                      <Button
                                        variant="outlined"
                                        size="small"
                                        fullWidth
                                        onClick={() => this.setState({ layoutPickerOpenPage: pageNumber, _pickerFilter: null })}
                                        style={{
                                          borderColor: pageLayoutError ? "#f44336" : "#1976d2",
                                          color: pageLayoutError ? "#f44336" : "#1976d2",
                                          textTransform: "none",
                                          fontSize: 11,
                                          marginBottom: 4,
                                        }}
                                      >
                                        {pageLayoutId ? "Change Layout" : "Browse Layouts…"}
                                      </Button>

                                      {pageLayoutError && (
                                        <Typography variant="caption" style={{ color: "#f44336", display: "block", marginBottom: 4 }}>
                                          {pageLayoutError}
                                        </Typography>
                                      )}

                                      <Typography variant="caption" style={{ color: "#888", display: "block", marginBottom: 4 }}>
                                        Shared for App & Print Asset
                                      </Typography>

                                      {/* ── Layout slot preview (selected layout) ── */}
                                      {(() => {
                                        const overlay = this.getCollageOverlay(pageLayoutId, pageNumber);
                                        return (
                                          <LayoutPreview
                                            exportWidth={overlay ? overlay.exportWidth : null}
                                            exportHeight={overlay ? overlay.exportHeight : null}
                                            collageInfoList={overlay ? overlay.collageInfoList : null}
                                          />
                                        );
                                      })()}

                                      {/* ── Picker dialog ── */}
                                      <LayoutPickerDialog
                                        open={this.state.layoutPickerOpenPage === pageNumber}
                                        onClose={() => this.setState({ layoutPickerOpenPage: null })}
                                        layoutsList={this.state.layoutsList}
                                        selectedLayoutId={pageLayoutId}
                                        pageNumber={pageNumber}
                                        getCollageOverlay={this.getCollageOverlay}
                                        initialFilter={this.state._pickerFilter ?? null}
                                        onSelect={(newLayoutId) => {
                                          this.setState((prev) => ({
                                            layoutPickerOpenPage: null,
                                            templateImages: prev.templateImages.map((slot) => {
                                              if (slot.pageNumber !== pageNumber) return slot;
                                              const updatedSlot = { ...slot, layoutId: newLayoutId, layoutIdError: "" };
                                              if (updatedSlot.file) {
                                                const generatedName = this.generateAssetFileName(updatedSlot);
                                                const renamedFile = new File([updatedSlot.file], generatedName, { type: updatedSlot.file.type });
                                                return { ...updatedSlot, file: renamedFile, generatedFileName: generatedName };
                                              }
                                              return updatedSlot;
                                            }),
                                          }));
                                        }}
                                      />
                                    </>
                                  );
                                })()}
                              </Card>
                            </Grid>

                          </Grid>
                          <Divider style={{ marginTop: 12 }} />
                        </Box>
                      );
                    })}
                  </Grid>
                )}

                {/* ── Action Buttons ── */}
                <Grid align="end" style={{ marginTop: 16 }} item xs={12}>
                  <Button
                    onClick={(e) => this.submitForm(e)}
                    className={classes.button}
                    color="primary"
                    variant="contained"
                    disabled={this.state.isLoading}
                  >
                    {this.state.isLoading ? (
                      <CircularProgress size={23} style={{ color: "white" }} />
                    ) : (
                      this.state.recordId == 0 ? "Save" : "Update"
                    )}
                  </Button>


                </Grid>

              </Grid>
            </CardContent>
          </Card>
        </Grid>
      </Fragment >
    );
  }
}

F15AddNewThemeForm.propTypes = {
  classes: PropTypes.object.isRequired,
  match: PropTypes.object,
};

F15AddNewThemeForm.defaultProps = {
  match: { params: { recordId: 0 } },
};
Object.assign(F15AddNewThemeForm.prototype, LayoutMethods);

export default withStyles(useStyles)(F15AddNewThemeForm);